<template>
  <div>
    <!-- DIV CON LOS ELEMENTOS DE LA CABECERA -->
    <div class="row">
      <!-- Breadcrumb -->
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'integraciones' }">{{
                $t("integraciones")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'businesscentral' }">{{
                $t("businessCentral")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("productos") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12" v-if="productosPendientes.length > 0">
        <!-- Componente Stepper -->
        <div class="col-md-12">
          <div>
            <div class="stepper-wrapper" :class="{ 'center-step-1': currentStep === 1 }">
              <div class="flex-container container">
                <div class="progress">
                  <div class="progress-bar" :style="{ width: progressWidth }"></div>
                </div>
                <div class="step" v-for="(step, i) in steps" :key="i" :class="{
                  done: step.number < currentStep,
                  current: step.number === currentStep,
                }">
                  <div class="step-number" :ref="setStepRef" :data-step="step.number">
                    <i v-if="step.number < currentStep" class="fa fa-check"></i>
                    <span v-else>{{ step.number }}</span>
                  </div>
                  <div class="step-label">{{ step.label }}</div>
                </div>
              </div>

              <!-- Stepper Buttons -->
              <div class="stepper-buttons">
                <button v-on:click="moveBackPressed" class="btn btn-warning fixed-width-button" role="button"
                  :class="{ hidden: currentStep === 1 }">
                  <i class="fa fa-chevron-left" aria-hidden="true"></i>
                  {{ $t("volver") }}
                </button>

                <button v-if="currentStep < steps.length" v-on:click="moveStep(currentStep + 1)"
                  :disabled="isContinueDisabled" class="btn btn-primary fixed-width-button continue-btn" role="button"
                  :class="{ hidden: currentStep === 1 }">
                  {{ $t("continuar") }}
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </button>

                <!--
                  Si el producto es CON o SUPLEMENTO (MostrarEnListaCON o MostrarEnListaSUPLEMENTO es true):
                    - El botón se deshabilita si allPricesValid es false
                    - Al hacer clic, solo ejecuta finalize() si allPricesValid es true

                  Si es un producto normal:
                    - El botón siempre está habilitado (a menos que haya otra lógica que lo deshabilite)
                    - Al hacer clic, ejecuta directamente finalize()
                -->
                <!-- <button v-else-if="currentStep == steps.length"
                  :disabled="(productoSeleccionado.MostrarEnListaCON || productoSeleccionado.MostrarEnListaSUPLEMENTO) ? !allPricesValid : false"
                  @click="(productoSeleccionado.MostrarEnListaCON || productoSeleccionado.MostrarEnListaSUPLEMENTO) ? (allPricesValid && finalize()) : finalize()"
                  class="btn fixed-width-button pull-right finalize-btn" role="button">
                  {{ $t('finalizar') }} <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </button> -->

                <button v-else-if="currentStep == steps.length" v-on:click="finalize"
                  class="btn btn-success fixed-width-button pull-right" role="button">
                  {{ $t("finalizar") }}
                  <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Componente Alert Info -->
          <div class="col-md-12">
            <div :class="{
              'alert-container-wide': currentStep === 1,
              'alert-container-normal': currentStep !== 1,
            }">
              <div class="alert alert-info" role="alert">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                <label v-if="currentStep === 1" v-html="$t('seleccionaProductosBusinessCentralAlertInfo', {
                  PRODUCT_LIST_LENGTH: productosPendientes.length,
                })
                  "></label>
                <label v-else-if="currentStep === 2" v-html="$t('seleccionaDepartamentosBusinessCentralAlertInfo', {
                  PRODUCT_NAME: productoSeleccionado.productName,
                })
                  "></label>
                <label v-else-if="currentStep === 3" v-html="$t('completarCamposProductosBusinessCentralAlertInfo', {
                  PRODUCT_NAME: productoSeleccionado.productName,
                })
                  "></label>
                <label v-else v-html="$t(
                  'asignarMateriasPrimasProductosBusinessCentralAlertInfo',
                  { PRODUCT_NAME: productoSeleccionado.productName }
                )
                  "></label>
              </div>
            </div>
          </div>
        </div>

        <!-- DIV CON LOS ELEMENTOS DEL BODY -->
        <div class="col-md-12">
          <div>
            <!-- Componente table con listado de productos -->
            <div v-if="currentStep === 1">
              <!-- Step 1: Seleccionar Producto -->

              <!-- Buscador -->
              <div class="search-container">
                <div class="search-input-wrapper">
                  <i class="fa fa-search search-icon"></i>
                  <input type="text" v-model="searchQuery" :placeholder="$t('buscarProducto')" class="search-input"
                    @input="onSearchInput" />
                  <button v-if="searchQuery" @click="clearSearch" class="clear-search-btn">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>

              <!-- Tabs -->
              <div class="tabs-container">
                <div class="tabs-bar">
                  <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'crear' }"
                        @click.prevent="setActiveTab('crear')" href="#">
                        {{ $t("crear") }} ({{ productsParaCrear.length }})
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" :class="{ active: activeTab === 'actualizar' }"
                        @click.prevent="setActiveTab('actualizar')" href="#">
                        {{ $t("actualizar") }} ({{
                          productsParaActualizar.length
                        }})
                      </a>
                    </li>
                    <!-- <li class="nav-item">
                      <a
                        class="nav-link"
                        :class="{ active: activeTab === 'noDisponibles' }"
                        @click.prevent="setActiveTab('noDisponibles')"
                        href="#"
                      >
                        {{ $t("noDisponible") }} ({{
                          productsNoDisponibles.length
                        }})
                      </a>
                    </li> -->
                  </ul>

                  <!-- Accion masiva: contextual a la pestana de actualizar -->
                  <div class="tabs-actions"
                    v-if="activeTab === 'actualizar' && productosAutoEditables.length > 0">
                    <button class="btn btn-success bulk-sync-btn" @click="sincronizarTodosAuto"
                      :title="$t('sincronizarTodosAutoTooltip')">
                      <i class="fa fa-bolt"></i>
                      <span class="bulk-sync-label">{{ $t("sincronizarTodos") }}</span>
                      <span class="bulk-sync-count">{{ productosAutoEditables.length }}</span>
                    </button>
                  </div>
                </div>
              </div>
              

              <!-- Tab panes: crear -->
              <div v-if="activeTab === 'crear'" class="tab-pane active">
                <div class="table-container">
                  <table class="product-table" v-if="currentPageProductos.length > 0">
                    <thead>
                      <tr>
                        <th>{{ $t("businessCentralCode") }}</th>
                        <th>{{ $t("nombreProducto") }}</th>
                        <th>{{ $t("iva") }}</th>
                        <th>{{ $t("seleccionar") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(producto, index) in currentPageProductos" :key="index">
                        <td>{{ producto.codProducto }}</td>
                        <td>{{ producto.productName }}</td>
                        <td>{{ producto.impuestoPorcentaje + "%" }}</td>
                        <td>
                          <button :class="[
                            'btn',
                            producto.tipoPendiente === 'pendienteActualizar'
                              ? 'btn-warning'
                              : 'btn-primary',
                            'select-btn',
                          ]" @click="seleccionarProducto(producto, true)">
                            <i :class="producto.tipoPendiente === 'pendienteActualizar'
                                ? 'fa fa-sync-alt icon-check-table'
                                : 'fa fa-plus icon-check-table'
                              "></i>
                            {{
                              producto.tipoPendiente === "pendienteActualizar"
                                ? $t("actualizar")
                                : $t("crear")
                            }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else class="no-results">
                    <p>{{ $t("noSeEncontraronProductos") }}</p>
                  </div>

                  <!-- Paginación -->
                  <div class="row" v-if="!isSearch && totalPags > 1">
                    <div class="col-md-12">
                      <div class="pagination-wrapper">
                        <nav>
                          <ul class="pagination">
                            <li class="page-item" :class="{ disabled: currentPage == 1 }">
                              <a class="page-link" @click.prevent="changePage(currentPage - 1)" v-if="currentPage != 1"
                                href="#">&laquo;</a>
                              <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                            </li>
                            <li class="page-item" v-for="n in visiblePages" :key="n"
                              :class="{ active: n == currentPage }">
                              <a class="page-link" @click.prevent="changePage(n)" href="#">{{ n }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage == totalPags }">
                              <a class="page-link" @click.prevent="changePage(currentPage + 1)"
                                v-if="currentPage != totalPags" href="#">&raquo;</a>
                              <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tab panel: actualizar -->
              <div v-if="activeTab === 'actualizar'" class="tab-pane active">
                <div class="table-container">
                  <table class="product-table" v-if="currentPageProductos.length > 0">
                    <thead>
                      <tr>
                        <th>{{ $t("businessCentralCode") }}</th>
                        <th>{{ $t("nombreProducto") }}</th>
                        <th>{{ $t("iva") }}</th>
                        <th>{{ $t("seleccionar") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(producto, index) in currentPageProductos" :key="index">
                        <td>{{ producto.codProducto }}</td>
                        <td>{{ producto.productName }}</td>
                        <td>
                          {{
                            producto.impuestoPorcentaje
                              ? producto.impuestoPorcentaje + "%"
                              : $t("sinIVA")
                          }}
                        </td>
                        <td>
                          <button :class="[
                            'btn',
                            producto.tipoPendiente === 'pendienteActualizar'
                              ? 'btn-warning'
                              : 'btn-primary',
                            'select-btn',
                          ]" @click="seleccionarProducto(producto)">
                            <i :class="producto.tipoPendiente === 'pendienteActualizar'
                                ? 'fa fa-sync-alt icon-check-table'
                                : 'fa fa-plus icon-check-table'
                              "></i>
                            {{
                              producto.tipoPendiente === "pendienteActualizar"
                                ? $t("actualizar")
                                : $t("crear")
                            }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else class="no-results">
                    <p>{{ $t("noSeEncontraronProductos") }}</p>
                  </div>

                  <!-- Paginación -->
                  <div class="row" v-if="!isSearch && totalPags > 1">
                    <div class="col-md-12">
                      <div class="pagination-wrapper">
                        <nav>
                          <ul class="pagination">
                            <li class="page-item" :class="{ disabled: currentPage == 1 }">
                              <a class="page-link" @click.prevent="changePage(currentPage - 1)" v-if="currentPage != 1"
                                href="#">&laquo;</a>
                              <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                            </li>
                            <li class="page-item" v-for="n in visiblePages" :key="n"
                              :class="{ active: n == currentPage }">
                              <a class="page-link" @click.prevent="changePage(n)" href="#">{{ n }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage == totalPags }">
                              <a class="page-link" @click.prevent="changePage(currentPage + 1)"
                                v-if="currentPage != totalPags" href="#">&raquo;</a>
                              <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tab panel: noDisponibles -->
              <div v-if="activeTab === 'noDisponibles'" class="tab-pane active">
                <div class="table-container">
                  <table class="product-table" v-if="currentPageProductos.length > 0">
                    <thead>
                      <tr>
                        <th>{{ $t("nombreProducto") }}</th>
                        <th>{{ $t("iva") }}</th>
                        <th>{{ $t("seleccionar") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(producto, index) in currentPageProductos" :key="index">
                        <td>{{ producto.productName }}</td>
                        <td>{{ producto.impuestoPorcentaje + "%" }}</td>
                        <td>
                          <button :class="[
                            'btn',
                            producto.tipoPendiente === 'pendienteActualizar'
                              ? 'btn-warning'
                              : 'btn-primary',
                            'select-btn',
                          ]" @click="seleccionarProducto(producto)">
                            <i :class="producto.tipoPendiente === 'pendienteActualizar'
                                ? 'fa fa-sync-alt icon-check-table'
                                : 'fa fa-plus icon-check-table'
                              "></i>
                            {{
                              producto.tipoPendiente === "pendienteActualizar"
                                ? $t("actualizar")
                                : $t("crear")
                            }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div v-else class="no-results">
                    <p>{{ $t("noSeEncontraronProductos") }}</p>
                  </div>

                  <!-- Paginación -->
                  <div class="row" v-if="!isSearch && totalPags > 1">
                    <div class="col-md-12">
                      <div>
                        <nav>
                          <ul class="pagination">
                            <li class="page-item" :class="{ disabled: currentPage == 1 }">
                              <a class="page-link" @click.prevent="changePage(currentPage - 1)" v-if="currentPage != 1"
                                href="#">&laquo;</a>
                              <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                            </li>
                            <li class="page-item" v-for="n in visiblePages" :key="n"
                              :class="{ active: n == currentPage }">
                              <a class="page-link" @click.prevent="changePage(n)" href="#">{{ n }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage == totalPags }">
                              <a class="page-link" @click.prevent="changePage(currentPage + 1)"
                                v-if="currentPage != totalPags" href="#">&raquo;</a>
                              <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Componente table con LISTADO DE DEPARTAMENTO (NORMAL)-->
            <div v-if="
              currentStep === 2 &&
              (this.productoSeleccionado.goToStepper === 0 ||
                !this.productoSeleccionado.goToStepper)
            ">
              <div class="row">
                <div class="departments-card checkbox-tree-container">
                  <h3>{{ $t("seleccionarDepartamentos") }}</h3>
                  <hr class="divider" />
                  <ul class="checkbox-tree">
                    <!-- Seleccionar todos -->
                    <li class="checkbox-item select-all-checkbox">
                      <input type="checkbox" id="selectAllTpvServersCheckbox" v-model="allTpvServerSelectedBoolean"
                        @change="selectAllTpvServers" class="custom-checkbox" />
                      <label for="selectAllTpvServersCheckbox">{{
                        $t("seleccionarTodos")
                      }}</label>
                    </li>

                    <!-- <p>{{ selectedTpvServerNameList }}</p>
                    <p>{{ selectedTpvServerList }}</p>
                    <p>AAAAA</p> -->

                    <!-- PARA DEBUG -->
                    <!-- <div class="test">
                      {{ selectedTpvServerList }}
                    </div> -->

                    <!-- Listado de departamentos -->
                    <li v-for="tpv in tpvServerList" :key="tpv.idTpvServer" style="list-style-type: none">
                      <div class="checkbox-item">
                        <input type="checkbox" :id="'tpv-' + tpv.idTpvServer" :value="tpv.nameShow"
                          v-model="selectedTpvServerNameList" @change="syncSelectedTpvServers()"
                          class="custom-checkbox" />
                        <label :for="'tpv-' + tpv.idTpvServer">{{
                          tpv.nameShow
                        }}</label>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- CARD DE DEPARTAMENTOS SELECCIONADOS -->
                <div class="departments-card">
                  <h3>{{ $t("departamentosSeleccionados") }}</h3>
                  <hr class="divider" />
                  <b-form-tags v-model="selectedTpvServerNameList" class="tags-container"
                    @input="syncSelectedTpvServers" readonly placeholder="" @focus="preventFocus"></b-form-tags>
                </div>
              </div>
            </div>

            <!-- Componente table con LISTADO DE DEPARTAMENTO (BLOQUEANDO DEPARTAMENTOS)-->
            <div v-if="
              currentStep === 2 && this.productoSeleccionado.goToStepper === 1
            ">
              <div class="row">
                <div class="departments-card checkbox-tree-container">
                  <h3>{{ $t("seleccionarDepartamentos") }}</h3>
                  <hr class="divider" />
                  <ul class="checkbox-tree">
                    <!-- Seleccionar todos -->
                    <li class="checkbox-item select-all-checkbox">
                      <input type="checkbox" id="selectAllTpvServersCheckbox" v-model="allTpvServerSelectedBoolean"
                        @change="selectAllTpvServers" class="custom-checkbox" :disabled="true" />
                      <label for="selectAllTpvServersCheckbox">{{
                        $t("seleccionarTodos")
                      }}</label>
                    </li>

                    <!-- Listado de departamentos -->
                    <li v-for="tpv in tpvServerList" :key="tpv.idTpvServer" style="list-style-type: none">
                      <div class="checkbox-item">
                        <input type="checkbox" :id="'tpv-' + tpv.idTpvServer" :value="tpv.nameShow"
                          v-model="selectedTpvServerNameList" @change="syncSelectedTpvServers()" class="custom-checkbox"
                          :disabled="true" />
                        <label :for="'tpv-' + tpv.idTpvServer">{{
                          tpv.nameShow
                        }}</label>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- CARD DE DEPARTAMENTOS SELECCIONADOS -->
                <div class="departments-card">
                  <h3>{{ $t("departamentosSeleccionados") }}</h3>
                  <hr class="divider" />
                  <b-form-tags v-model="selectedTpvServerNameList" class="tags-container"
                    @input="syncSelectedTpvServers" readonly placeholder="" @focus="preventFocus"
                    :disabled="true"></b-form-tags>
                </div>
              </div>
            </div>

            <!-- Componente formulario con datos de producto. Le pasamos como props productoSeleccionado, listCategory, selectedDepartmentsObjectsList y listIva -->
            <div v-if="currentStep === 3">
              <div class="row">
                <div class="product-fields-container">
                  <ProductoFormCompleto v-if="
                    productoSeleccionado.MostrarEnListaCON ||
                    productoSeleccionado.MostrarEnListaSUPLEMENTO
                  " :productoSeleccionado="productoSeleccionado" :selectedTpvServerList="selectedTpvServerList"
                    :listCategoriesByBusiness="listCategoriesByBusiness" :finalizeButtonPressed="finalizeButtonPressed"
                    :moveBackButtonPressed="moveBackButtonPressed"
                    :productosPorTpvRecuperados="productosPorTpvRecuperados"
                    :continueButtonPressedOnStep3="continueButtonPressedOnStep3"
                    :productsDataToFillForm="productsDataToFillForm" :productDataInfo="productDataInfo"
                    :product-type-flags="productTypeFlags" :isNewProduct="productoSeleccionado.tipoPendiente ===
                      'pendienteSincronizar'
                      " :ignoreMultipleUDMedida="ignoreMultipleUDMedida"
                    :resetProductoFormBasico="resetProductoFormBasico" :saved-form-data="savedComplexFormData"
                    @move-back-to-step2="moveBackToStep2" @continue-to-step4="handleContinueToStep4" />
                  <ProductoFormBasico v-else :productoSeleccionado="productoSeleccionado"
                    :selectedTpvServerList="selectedTpvServerList" :listCategoriesByBusiness="listCategoriesByBusiness"
                    :finalizeButtonPressed="finalizeButtonPressed" :moveBackButtonPressed="moveBackButtonPressed"
                    :productosPorTpvRecuperados="productosPorTpvRecuperados" :productDataInfo="productDataInfo"
                    :crearMultiplesProductosByUdsMedida="crearMultiplesProductosByUdsMedida
                      " :productosMultiples="productosMultiples"
                    :continueButtonPressedOnStep3="continueButtonPressedOnStep3"
                    :productsDataToFillForm="productsDataToFillForm" :resetProductoFormBasico="resetProductoFormBasico"
                    :activeDepartments="activeDepartments" @move-back-to-step2="moveBackToStep2"
                    @continue-to-step4="continueToStep4" />
                </div>
              </div>
            </div>

            <!-- Componente con listado de materias Primas -->
            <div v-if="currentStep === 4 && !rateFlag">
              <div class="materias-primas-container">
                <div class="materias-primas-list">
                  <div v-for="(linea, index) in recetaSeleccionada" :key="index" class="materia-prima-item">
                    <div class="materia-prima-content">
                      <i class="fa fa-check-circle text-success" v-if="
                        addMateriaPrimaButtonsPressed.includes(
                          linea.idMateriaPrimaBusinessCentral
                        )
                      "></i>
                      <i class="fa fa-circle-o" v-else></i>
                      <span class="materia-prima-name">{{
                        linea.nombreMateriaPrima
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="materias-primas-note">
                  {{ $t("estasMateriasPrimasSeAnadiranAlProducto") }}
                </div>
              </div>
            </div>

            <!-- Componente con listado de materias Primas (se puede poner precio - caso suplementos) -->
            <!-- No se usa por ahora -->
            <div v-else-if="currentStep === 4 && rateFlag" class="col-12 mt-3">
              <div class="card mb-4">
                <div class="card-header py-2 px-3">
                  <h4 class="card-title mb-0">{{ $t("materiasPrimas") }}</h4>
                </div>
                <div class="card-body p-3">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered mb-0">
                      <thead class="thead-dark">
                        <tr>
                          <th>{{ $t("materiaPrima") }}</th>
                          <th class="text-right">{{ $t("precio") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(linea, index) in recetaSeleccionada" :key="'mp-' + index">
                          <td class="align-middle">
                            {{ linea.nombreMateriaPrima }}
                          </td>
                          <td class="text-right" style="width: 150px">
                            <vue-numeric v-model="linea.precioMateriaPrima"
                              class="form-control form-control-sm text-right" :precision="2" :min="0" :empty-value="0"
                              currency="€" separator="," currency-symbol-position="suffix"
                              style="max-width: 120px; margin-left: auto" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="materias-primas-note mt-3">
                    {{ $t("asignaPreciosMateriasPrimas") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de alerta cuando no haya productos pendientes -->
      <div v-else class="col-md-12" align="center">
        <div class="alert alert-primary" align="center">
          <h3>
            <i class="fas fa-exclamation-circle"></i>
            {{ $t("esteNegocioNoTieneProductosParaSincronizar") }}.
          </h3>
        </div>
      </div>
    </div>

    <modal v-if="
      productoSeleccionado &&
      productoSeleccionado.udMedida &&
      productoSeleccionado.udMedida.length > 1 &&
      (!productoSeleccionado.MostrarEnListaCON ||
        !productoSeleccionado.MostrarEnListaSUPLEMENTO)
    " :name="'modal-unidades-medida'" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true">
      <div style="padding: 25px 30px">
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("modalUnidadesMedidaTitle") }}</h4>
        </div>

        <div class="modal-body">
          <p>
            <strong>{{ productoSeleccionado.productName }}</strong>
            {{
              $t("modalUnidadesMedidaTextIntro", {
                PRODUCT_NAME: productoSeleccionado.productName,
                UD_COUNT: productoSeleccionado.udMedida
                  ? productoSeleccionado.udMedida.length
                  : 0,
                UD_LIST: productoSeleccionado.udMedida
                  ? productoSeleccionado.udMedida.join(", ")
                  : "",
              })
            }}
          </p>

          <p v-if="productoSeleccionado.udMedida.length <= 4">
            {{ $t("modalUnidadesMedidaOpcionUnico") }}
          </p>
          <p v-else>
            {{ $t("modalUnidadesMedidaOpcionUnicoMasDeCuatro") }}
          </p>

          <p>
            {{
              $t("modalUnidadesMedidaOpcionMultiples", {
                UD_COUNT: productoSeleccionado.udMedida
                  ? productoSeleccionado.udMedida.length
                  : 0,
              })
            }}
          </p>



          <p>
            {{
              $t("modalUnidadesMedidaRecomendacion", {
                UD_COUNT: productoSeleccionado.udMedida
                  ? productoSeleccionado.udMedida.length
                  : 0,
              })
            }}
          </p>
        </div>

        <div class="modal-footer">
          <button class="btn btn-success" @click="crearMultiplesProductosByUdMedida">
            {{
              $t("modalUnidadesMedidaButtonMultiples", {
                UD_COUNT: productoSeleccionado.udMedida
                  ? productoSeleccionado.udMedida.length
                  : 0,
              })
            }}
          </button>

          <button v-if="productoSeleccionado.udMedida.length <= 4" class="btn btn-success"
            @click="crearUnProductoByUdMedida">
            {{ $t("modalUnidadesMedidaButtonUnico") }}
          </button>
        </div>
      </div>
    </modal>

    <!-- Modal para añadir el precio del suplemento -->
    <modal name="supplement-price-modal" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true"
      @before-close="resetSupplementPrice">
      <div>
        <div class="modal-header">
          <!-- Título -->
          <h4 style="margin: 0px">{{ $t("addSupplementPriceTitle") }}</h4>
          <button type="button" class="close" aria-label="Close" @click="closeSupplementPriceModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <!-- Texto explicativo del modal -->
          <p class="text-muted" style="text-align: justify" v-html="$t('addSupplementPriceText', {
            PRODUCT_NAME: productoSeleccionado.productName,
          })
            "></p>

          <!-- Campo para ingresar el precio del suplemento -->
          <div class="form-group">
            <label>
              <strong>{{ $t("addSupplementPriceInputLabel") }}</strong>
            </label>

            <vue-numeric class="form-control form-control-lg text-right" style="height: auto; padding: 0.5rem" :class="{
              'is-valid': suplementPrice > 0,
              'is-invalid': suplementPrice === 0,
            }" :value="suplementPrice || 0" @input="suplementPrice = $event" :precision="2" :min="0" :empty-value="0"
              separator="," currency=" €" currency-symbol-position="suffix" />
          </div>
        </div>

        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="saveSupplementPrice" class="btn btn-primary">
              <i class="fas fa-save"></i>
              {{ $t("guardar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- <modal v-if="productoSeleccionado" :name="'modal-confirmar-datos_form'" :adaptive="true" :scrollable="true"
      height="auto" :clickToClose="false">
      <div style="padding: 25px 30px">
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("modalConfirmarDatosTitle") }}</h4>
        </div>

        <div class="modal-body">
          <p>
            {{
              $t("modalConfirmarDatosIntro", {
                PRODUCT_NAME: productoSeleccionado.productName
              })
            }}
          </p>

          <p>
            {{ $t("modalConfirmarDatosExplicacion") }}
          </p>
        </div>

        <div class="modal-footer">
          <button class="btn btn-success" @click="ocultarModalActualizarProducto">
            {{ $t("continuar") }}
          </button>
        </div>
      </div>
    </modal> -->
  </div>
</template>

<script>
import ProductoFormBasico from "./ProductoFormBasico";
import ProductoFormCompleto from "./ProductoFormCompleto";
import Swal from "sweetalert2";

import { Loading } from "element-ui";
import { Select, Option } from "element-ui";
import VueNumeric from "vue-numeric";

// Vamos a asegurarnos de que el IVA no se suponga ni Autosetée en casos especiales
// en ciertos flujos antes del cambio, al actualizar en modo manual con formulario o auto
// provocaban mutaciones de iva de 0 a 10 o al reves no deseadas o que simplemente no se
// actualizaban
function primerIva() {
  for (var i = 0; i < arguments.length; i++) {
    var valor = arguments[i];
    if (valor === null || valor === undefined || valor === "") continue;
    var numero = parseFloat(valor);
    if (!isNaN(numero)) return numero;
  }
  return 10;
}

export default {
  created() {
    // Guardamos el la businessList pasado como parámetro en la variable local
    this.listBusinesses = this.$route.params.listBusinesses;

    // Si no existe listBusinesses, establecemos shouldRedirect en true y redirigimos
    if (!this.listBusinesses) {
      console.warn(
        " > Listado de negocios no encontrado, redirigiendo a integraciones..."
      );
      this.shouldRedirect = true;
      this.$router.push({
        name: "integraciones",
        params: { redirected: true },
      });
      return;
    }

    // Si tenemos los datos de productos del componente padre, los usamos
    if (this.$route.params.productosData) {
      this.productosPendientes = this.$route.params.productosData;
    } else {
      // Si no hay datos del padre, los cargamos desde la API
      // this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      // this.getProductosFromBusinessCentral();
    }

    // Estas peticiones son necesarias independientemente

  },

  async mounted() {
    if (this.shouldRedirect) return;

    try {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      // console.log(" > Mounted, cargando datos iniciales...");
      // Estas otras peticiones son necesarias independientemente

      const promises = [
        this.getCategoryListByBusinessList(),
        this.getTpvServerListByBusinessList(),
        this.getProductosElaboradosSemielaboradosFromBusinessCentral(),
        this.getSubproductsNumierBySubproductsBusinessCentral(),
      ]
      if (!this.$route.params.productosData) {
        promises.push(this.getProductosFromBusinessCentral(false));
      }
      await Promise.all(promises);

      if (this.tpvServerList.length > 0) {
        await this.getSubproductsByBusinessList();
      }
    } catch (error) {
      console.error("Error de carga de datos iniciales:", error);
    } finally {
      if (this.loadingGeneral) {
        this.loadingGeneral.close();
      }
    }

    window.addEventListener("resize", this.updateProgressBar);

    this.$nextTick(() => {
      this.$nextTick(() => {
        this.updateProgressBar();
      });
    });

    window.addEventListener("beforeunload", this.preventReload);
  },

  watch: {
    listCategoriesByBusiness(newValue) {
      // console.log(" > listCategoriesByBusiness watcheada", newValue);
    },

    productoSeleccionado: {
      handler(nuevoProducto) {
        if (!nuevoProducto) {
          this.recetaSeleccionada = [];
          return;
        }

        // Si ya hay una receta seleccionada y estamos en step 4 o más, no volver a cargar
        if (this.currentStep >= 4 && this.recetaSeleccionada.length > 0) {
          // console.log(" > Ya hay receta cargada y estamos en step >= 4, no recargar.");
          return;
        }

        // Producto simple (sin subproductos)
        if (
          nuevoProducto.esProduct === true &&
          nuevoProducto.tieneSubproducts === false
        ) {
          const base = this.getModeloBaseReceta();
          this.recetaSeleccionada = [
            {
              ...base,
              nombreMateriaPrima: nuevoProducto.productName,
              idMateriaPrimaBusinessCentral:
                nuevoProducto.idProdBusinessCentral,
              tipoMateriaPrima: nuevoProducto.tipoMateriaPrima || "B",
            },
          ];
          // console.log(" > Producto simple cargado en recetaSeleccionada:", this.recetaSeleccionada);
          return;
        }

        // Producto con receta (subproductos)
        if (
          nuevoProducto.idProdBusinessCentral &&
          this.recetasFromBusinessCentral
        ) {
          const recetasFiltradas = this.recetasFromBusinessCentral.filter(
            (receta) =>
              receta.idRecetaBusinessCentral ==
              nuevoProducto.idProdBusinessCentral
          );

          if (this.currentStep < 4) {
            this.recetaSeleccionada = recetasFiltradas.map((lineaOriginal) => {
              const base = this.getModeloBaseReceta();
              return {
                ...base,
                ...lineaOriginal,
                tipoMateriaPrima: lineaOriginal.tipoMateriaPrima || "B",
                variacionPrecio: lineaOriginal.variacionPrecio || 0,
                editado: false,
              };
            });
          }
          // console.log(" > Receta seleccionada:", this.recetaSeleccionada);
        } else {
          this.recetaSeleccionada = [];
        }
      },
      immediate: true,
      deep: true,
    },

    recetaSeleccionada: {
      deep: true,
      handler(val) {
        if (!val || val.length === 0) {
          this.allPricesValid = false;
          return;
        }

        // Verifico que todos los precios sean mayores a 0.00
        this.allPricesValid = val.every((materia) => {
          const precio = parseFloat(materia.precioMateriaPrima);
          return !isNaN(precio) && precio > 0;
        });
      },
    },

    // tpvServerList: {
    //   handler(nuevaLista) {
    //     if (Array.isArray(nuevaLista) && nuevaLista.length > 0) {
    //       // console.log(" > tpvServerList cargado, obteniendo subproductos...");
    //       this.getSubproductsByBusinessList();
    //     }
    //   },
    //   immediate: false, // no se llama al montar (porque aún no hay datos)
    //   deep: true, // por si tpvServerList cambia
    // },

    addAllMateriaPrimaButtonPressed(nuevoValor) {
      if (
        nuevoValor === true &&
        this.subproductsNumierByBusinessCentral &&
        Array.isArray(this.subproductsNumierByBusinessCentral)
      ) {
        this.actualizarProductosPorTpvConMateriasPrimas();
      }
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateProgressBar);
    window.removeEventListener("beforeunload", this.preventReload);
  },

  beforeRouteLeave(to, from, next) {
    // console.log(" > Intentando salir de:", from.fullPath);
    // console.log(" > Intentando ir a:", to.fullPath);

    if (!this.shouldRedirect && this.productosPendientes.length > 0) {
      Swal.fire({
        title: this.$t("swalSalirFromProductosBusinessCentralTitle"),
        text: this.$t("swalSalirFromProductosBusinessCentralText"),
        type: "info",
        showCancelButton: true,
        cancelButtonClass: "btn btn-secondary btn-fill",
        confirmButtonClass: "btn btn-danger btn-fill",
        confirmButtonColor: "#d33",
        confirmButtonText: this.$t(
          "swalSalirFromProductosBusinessCentralButtonConfirm"
        ),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
        focusCancel: true,
      }).then((result) => {
        if (result.value) {
          // console.log(" > Confirmado. Navegando a:", to.fullPath);
          next();
        } else {
          // console.log(" > Cancelada la navegación.");
          next(false);
        }
      });
    } else {
      next();
    }
  },

  components: {
    ProductoFormBasico,
    ProductoFormCompleto,
    "el-select": Select,
    "el-option": Option,
    "vue-numeric": VueNumeric,
  },
  data() {
    return {
      allPricesValid: false, // Para controlar si todos los precios son válidos (suplementos)
      promesasCarga: null, // Promesas que tengo en segundo plano
      loadingGeneral: null,
      shouldRedirect: false,
      rateFlag: false,
      progressWidth: "0px",
      currentStep: 1,
      steps: [
        { number: 1, label: this.$t("seleccionarProducto") },
        { number: 2, label: this.$t("seleccionarDepartamentos") },
        { number: 3, label: this.$t("completarCampos") },
        { number: 4, label: this.$t("asignarMateriasPrimas") },
      ],
      productosPendientes: [
        {
          idProdBusinessCentral: 1,
          productName: this.$t("cargandoListaProductos"),
          impuestoPorcentaje: "10",
        },
      ],

      productosPendientesFromBusinessCentral: [],

      productoSeleccionado: {
        idProdBusinessCentral: 0,
        productName: "",
        tipoIVA: "",
        udMedida: [],
      },
      // Params
      listBusinesses: [],
      tpvServerList: [],

      // Lista de los TPVs Servidores seleccionada en el Step2
      selectedTpvServerList: [],
      selectedTpvServerNameList: [],
      allTpvServerSelectedBoolean: false,

      listCategoriesByBusiness: [],

      finalizeButtonPressed: false, // Es posible que el finalizeButtonPressed no sea necesario, pertenece al legacy de cuando se guardaba en el productoFormBasico
      moveBackButtonPressed: false,
      productosPorTpvRecuperados: null,
      waitingForProductsData: false,
      crearMultiplesProductosByUdsMedida: false,
      continueButtonPressedOnStep3: false,
      recetasFromBusinessCentral: [],
      subproductsByBusinessList: [],
      subproductsNumierByBusinessCentral: [],
      addMateriaPrimaButtonsPressed: [],
      addAllMateriaPrimaButtonPressed: false,

      recetaSeleccionada: [],
      // Materias primas
      listaTipo: [
        { label: this.$t("base"), value: "B" },
        { label: this.$t("extra"), value: "E" },
        { label: this.$t("opcional"), value: "O" },
      ],
      productsDataToFillForm: [],
      productTypeFlags: {
        type_swap_con_to_suple: false,
        type_swap_suple_to_con: false,
        type_add_suple: false,
        type_add_con: false,
        type_remove_suple: false,
        type_remove_con: false,
        type_remove_all_con_suple: false,
        type_new_con: false,
        type_new_suple: false,
        type_new_con_suple: false,
        type_invalid_transmutation: false,
        requires_full_form: false,
        transparent_update: false,
      },
      requiresSuplePriceModal: false,
      suplementPrice: 0,
      priceVariationsByTpv: [],
      resetProductoFormBasico: false,
      udMedidaChoiceMade: false,
      eraSimpleAntesFlag: false,
      productosMultiples: [],
      ignoreMultipleUDMedida: false,

      // Para persistencia de datos del formulario completo
      savedComplexFormData: null,

      // UI state: busqueda, tabs, paginacion
      activeTab: "crear",
      searchQuery: "",
      isSearch: false,
      currentPage: 1,
      itemsPerPage: 30,
      activeDepartments: [],

      // Datos del producto normal o CON/SUPLE
      productDataInfo: {},
      isProcessingStep4: false,
    };
  },
  computed: {
    isContinueDisabled() {
      if (this.currentStep === 1) {
        // Deshabilitar si no hay producto seleccionado con nombre válido
        return (
          !this.productoSeleccionado || !this.productoSeleccionado.productName
        );
      }
      if (this.currentStep === 2) {
        // Deshabilitar si no hay TPVs seleccionados
        return this.selectedTpvServerList.length === 0;
      }
      return false;
    },

    // Listas por categoría
    productsParaCrear() {
      if (!Array.isArray(this.productosPendientes)) return [];

      const base = this.productosPendientes.filter(
        (p) => p.tipoPendiente === "pendienteSincronizar"
      );

      const q = (this.searchQuery || "").toString().trim().toLowerCase();
      if (!q) return base;

      return base.filter((p) => {
        const name = (p.productName || "").toLowerCase();
        const id = (p.idProdBusinessCentral || "").toString().toLowerCase();

        return name.includes(q) || id.includes(q);
      });
    },
    productsParaActualizar() {
      if (!Array.isArray(this.productosPendientes)) return [];
      const base = this.productosPendientes.filter(
        (p) => p.tipoPendiente === "pendienteActualizar"
      );
      const q = (this.searchQuery || "").toString().trim().toLowerCase();
      if (!q) return base;
      return base.filter((p) =>
        (p.productName || "").toString().toLowerCase().includes(q)
      );
    },
    productsNoDisponibles() {
      if (!Array.isArray(this.productosPendientes)) return [];
      const base = this.productosPendientes.filter(
        (p) =>
          p.tipoPendiente !== "pendienteSincronizar" &&
          p.tipoPendiente !== "pendienteActualizar"
      );
      const q = (this.searchQuery || "").toString().trim().toLowerCase();
      if (!q) return base;
      return base.filter((p) =>
        (p.productName || "").toString().toLowerCase().includes(q)
      );
    },

    // Lista según tab activo
    currentTabProductos() {
      switch (this.activeTab) {
        case "crear":
          return this.productsParaCrear;
        case "actualizar":
          return this.productsParaActualizar;
        case "noDisponibles":
          return this.productsNoDisponibles;
        default:
          return [];
      }
    },

    // Filtrado por búsqueda
    filteredProductos() {
      const q = (this.searchQuery || "").toString().trim().toLowerCase();
      if (!q) return this.currentTabProductos;

      return this.currentTabProductos.filter((p) => {
        const name = (p.productName || "").toLowerCase();
        const id = (p.idProdBusinessCentral || "").toString().toLowerCase();

        return name.includes(q) || id.includes(q);
      });
    },

    // Paginación
    totalPags() {
      return Math.ceil(this.filteredProductos.length / this.itemsPerPage);
    },

    visiblePages() {
      const max = 15;
      const total = this.totalPags;
      const current = this.currentPage;
      if (!total || total <= 1) return [1];
      if (total <= max) return Array.from({ length: total }, (_, i) => i + 1);

      const half = Math.floor(max / 2);
      let start = Math.max(1, current - half);
      let end = start + max - 1;
      if (end > total) {
        end = total;
        start = end - max + 1;
      }
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    currentPageProductos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredProductos.slice(start, start + this.itemsPerPage);
    },

    productosAutoEditables() {
      if (!Array.isArray(this.productosPendientes)) return [];

      return this.productosPendientes.filter((p) => {
        if (p.tipoPendiente !== "pendienteActualizar") return false;

        const flags = p.flags || {};

        // Caso CON/SUPLEMENTO: solo entra si el cambio es transparente (no requiere formulario)
        if (flags.requires_full_form) {
          return !!flags.transparent_update && !flags.type_invalid_transmutation;
        }

        // Caso normal: solo si no hay cambios de formato/unidad de medida pendientes
        return p.goToStepper !== 1 && !p.changeFormatToRates;
      });
    },
  },
  methods: {
    // Métodos para tabs, búsqueda y paginación
    setActiveTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab;
        this.currentPage = 1; // Resetar la paginación cuando cambia entre tabs
      }
    },

    onSearchInput() {
      this.isSearch = this.searchQuery.length > 0;
      this.currentPage = 1; // Resetar la paginación cuando se realiza una búsqueda
    },

    clearSearch() {
      if (this.searchQuery) {
        this.searchQuery = "";
        this.isSearch = false;
        this.currentPage = 1;
      }
    },

    handleSearchInput() {
      this.isSearch = !!this.searchQuery;
      this.currentPage = 1;
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPags) {
        this.currentPage = page;
      }
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage -= 1;
    },
    nextPage() {
      if (this.currentPage < this.totalPags) this.currentPage += 1;
    },

    // Deja cada fila con solo los campos de su tipo (regla de la API):
    //   Simple/Formatos -> unidad en PLU3; PLU4 y namePrice1..4 vacíos
    //   Tarifas         -> nombres de tarifa en namePrice; PLU3 y PLU4 vacíos
    //   CON-SUPLEMENTO  -> no se toca aquí
    // Caso típico: un tarifado que se queda con una sola tarifa pasa a Simple; la única tarifa
    // con nombre es la unidad y su precio pasa a price1.
    ajustarCamposPorTipo: function (p) {
      if (!p) return p;
      var tipo = String(p.PLU2 || "").trim();
      var k;

      // Un tarifado con una sola tarifa (o ninguna) con nombre ya no es Tarifas: pasa a Simple.
      if (tipo === "Tarifas") {
        var tarifasConNombre = 0;
        for (k = 1; k <= 4; k++) {
          if (String(p["namePrice" + k] || "").trim()) tarifasConNombre++;
        }
        if (tarifasConNombre <= 1) {
          tipo = "Simple";
          p.PLU2 = "Simple";
        }
      }

      if (tipo === "Simple" || tipo === "Formatos") {
        if (!String(p.PLU3 || "").trim()) {
          for (k = 1; k <= 4; k++) {
            var nombre = String(p["namePrice" + k] || "").trim();
            if (nombre) {
              p.PLU3 = nombre;
              if (k > 1 && !Number(p.price1) && p["price" + k] !== undefined) {
                p.price1 = p["price" + k];
              }
              break;
            }
          }
          if (!String(p.codUdMedida || "").trim()) p.codUdMedida = p.PLU3 || "";
        }
        for (k = 1; k <= 4; k++) {
          p["namePrice" + k] = "";
          p["selPrice" + k] = false;
        }
        p.PLU4 = "";
      } else if (tipo === "Tarifas") {
        // Solo lo que se escribe en BD. codUdMedida NO se toca: la API lo usa para emparejar
        // la fila con el producto existente en el stepper (editProductBC).
        p.PLU3 = "";
        p.PLU4 = "";
        // Una tarifa sin nombre ya no existe: se apaga su selPrice para que no se venda.
        for (k = 1; k <= 4; k++) {
          if (!String(p["namePrice" + k] || "").trim()) {
            p["selPrice" + k] = false;
          }
        }
      }
      return p;
    },

    normalizeProductosNumier: function (productosNumier, productDataInfo) {

      var prodSel = this.productoSeleccionado;

      // DETECCIÓN DE MÚLTIPLES FORMATOS
      // Si el array contiene elementos donde PLU2 === "Formatos", es un caso de múltiples formatos
      var esMultiplesFormatos =
        productosNumier.length > 0 &&
        productosNumier.some(function (item) {
          var prod = item.producto || item;
          return prod.PLU2 === "Formatos";
        });

      var esTarifas =
        productosNumier.length > 0 &&
        productosNumier.some(function (item) {
          var prod = item.producto || item;
          return prod.PLU2 === "Tarifas";
        });

      if (esMultiplesFormatos) {
        // CASO: MÚLTIPLES FORMATOS
        // Los items vienen como array plano, cada uno es un formato diferente
        // console.log("Procesando como MÚLTIPLES FORMATOS");

        // Obtener PLU1 desde productDataInfo
        var plu1 = null;
        var udsMedida = new Set();

        if (
          Object.keys(productDataInfo) &&
          Object.keys(productDataInfo.tpvs).length > 0
        ) {
          Object.keys(productDataInfo.tpvs).forEach(function (tpvId) {
            var tpvData = productDataInfo.tpvs[tpvId];

            if (
              tpvData &&
              tpvData.productos &&
              Array.isArray(tpvData.productos)
            ) {
              tpvData.productos.forEach(function (prodWrapper) {
                if (prodWrapper.producto) {
                  var prod = prodWrapper.producto;
                  if (!plu1 && prod.PLU1) {
                    plu1 = prod.PLU1;
                  }
                  // QUITADO: No agregar unidades existentes a udsMedida para permitir reducción
                }
              });
            }
          });
        }

        // AGREGAR TAMBIÉN LAS UNIDADES NUEVAS DESDE productosNumier
        productosNumier.forEach(function (item) {
          var prod = item.producto || item;
          if (prod.PLU3) {
            udsMedida.add(prod.PLU3);
          }
        });

        if (!plu1) {
          console.warn("No se encontró PLU1 en productDataInfo");
          return { tpvs: [] };
        }

        // DETECTAR TRANSICIÓN A SIMPLE
        var finalPlu2 = udsMedida.size === 1 ? "Simple" : "Formatos";
        // console.log("[BC] finalPlu2 determinado:", finalPlu2);

        // Crear estructura base del producto desde prodSel
        var productoBase = {
          idProdBusinessCentral: plu1,
          productName:
            prodSel && prodSel.productName ? prodSel.productName : "",
          tipoIVA: prodSel && prodSel.tipoIVA ? prodSel.tipoIVA : "IVA10",
          impuestoPorcentaje: primerIva(prodSel && prodSel.impuestoPorcentaje),
          esProduct: prodSel && prodSel.esProduct ? prodSel.esProduct : true,
          lastDateModifiedBC: new Date().toISOString(),
          tieneSubproducts: udsMedida.size > 1,
          tipoPendiente: "pendienteActualizar",
          fromRatesToFormats: finalPlu2 === "Formatos" ? 1 : 0,
          idNumier:
            prodSel &&
              prodSel.idsNumier &&
              prodSel.idsNumier[0] &&
              prodSel.idsNumier[0].idNumier
              ? prodSel.idsNumier[0].idNumier
              : prodSel && prodSel.idNumier
                ? prodSel.idNumier
                : "",
          udMedida: Array.from(udsMedida),
          idMateriasPrimas:
            prodSel && prodSel.idMateriasPrimas
              ? prodSel.idMateriasPrimas.slice()
              : [],
          MostrarEnListaCON:
            prodSel && prodSel.MostrarEnListaCON
              ? prodSel.MostrarEnListaCON
              : false,
          MostrarEnListaSUPLEMENTO:
            prodSel && prodSel.MostrarEnListaSUPLEMENTO
              ? prodSel.MostrarEnListaSUPLEMENTO
              : false,
        };

        // console.log("productoBase", productoBase);
        // console.log("udsMedida", udsMedida);

        // Procesar datos desde productosNumier
        var productosPorTpv = {};

        // Agrupar productos por TPV desde productDataInfo
        Object.keys(productDataInfo.tpvs).forEach(function (tpvId) {
          if (!productosPorTpv[tpvId]) {
            productosPorTpv[tpvId] = [];
          }
        });

        // Para cada formato en productosNumier
        productosNumier.forEach(function (item) {
          var prodFormato = item.producto || item;
          var plu3Formato = prodFormato.PLU3 || "";

          // Iterar sobre cada TPV desde productDataInfo
          Object.keys(productDataInfo.tpvs).forEach(function (tpvId) {
            if (
              prodFormato.idTpvServer &&
              String(prodFormato.idTpvServer) !== String(tpvId)
            ) {
              return;
            }
            // Si es transición a Simple, no concatenamos la unidad al nombre
            var nombreProducto = this.normalizarNombreProducto(
              prodFormato.nombreProducto || prodFormato.productName,
              finalPlu2 === "Simple" ? "" : plu3Formato
            );

            var productoProcesado = {
              nombreProducto: nombreProducto,
              idProd: this.setIdProd2(prodSel, tpvId, plu3Formato),
              codUdMedida: plu3Formato,
              descripcion: prodFormato.descripcion || "",
              codigoBarras: prodFormato.codigoBarras || "",
              idCategory: prodFormato.idCategory || 0,
              tipoIva: primerIva(prodFormato.tipoIva, prodFormato.iva),
              color: prodFormato.color || "amarillo",
              selPrice1: prodFormato.selPrice1 || false,
              selPrice2: prodFormato.selPrice2 || false,
              selPrice3: prodFormato.selPrice3 || false,
              selPrice4: prodFormato.selPrice4 || false,
              price1: prodFormato.price1 || 0,
              price2: prodFormato.price2 || 0,
              price3: prodFormato.price3 || 0,
              price4: prodFormato.price4 || 0,
              namePrice1: prodFormato.namePrice1 || "",
              namePrice2: prodFormato.namePrice2 || "",
              namePrice3: prodFormato.namePrice3 || "",
              namePrice4: prodFormato.namePrice4 || "",
              orden: parseInt(prodFormato.orden) || 999,
              PLU1: plu1,
              PLU2: finalPlu2,
              PLU3: plu3Formato,
              PLU4: "",
              grupo_enlazado: prodFormato.grupo_enlazado || "",
              active: "1",
            };

            // console.log("Producto formato procesado:", productoProcesado);
            productosPorTpv[tpvId].push(this.ajustarCamposPorTipo(productoProcesado));
          }, this);
        }, this);

        // console.log("productosPorTpv", productosPorTpv);

        // Convertir productosPorTpv a tpvGroups
        var tpvGroups = [];
        Object.keys(productosPorTpv).forEach(function (tpvId) {
          tpvGroups.push({
            idTpv: tpvId,
            prods: productosPorTpv[tpvId],
          });
        });

        // console.log("Estructura final normalizada (Múltiples Formatos):", {
        //   productBC: productoBase,
        //   tpvs: tpvGroups,
        // });

        if (!productoBase.udMedida.length) {
          productoBase.udMedida = prodSel.udMedida;
        }

        return {
          productBC: productoBase,
          tpvs: tpvGroups,
        };

      } else if (esTarifas) {
        // CASO: TARIFAS
        // Un único producto con múltiples tarifas
        // console.log("Procesando como TARIFAS");

        // Obtener PLU1 desde productDataInfo
        var plu1 = null;
        var udsMedida = new Set();

        if (
          Object.keys(productDataInfo) &&
          Object.keys(productDataInfo.tpvs).length > 0
        ) {
          Object.keys(productDataInfo.tpvs).forEach(function (tpvId) {
            var tpvData = productDataInfo.tpvs[tpvId];

            if (
              tpvData &&
              tpvData.productos &&
              Array.isArray(tpvData.productos)
            ) {
              tpvData.productos.forEach(function (prodWrapper) {
                if (prodWrapper.producto) {
                  var prod = prodWrapper.producto;
                  if (!plu1 && prod.PLU1) {
                    plu1 = prod.PLU1;
                  }
                  // QUITADO: No agregar unidades existentes a udsMedida
                }
              });
            }
          });
        }

        // AGREGAR TAMBIÉN LAS UNIDADES NUEVAS DESDE productosNumier
        productosNumier.forEach(function (item) {
          var prod = item.producto || item;
          if (prod.PLU3) {
            udsMedida.add(prod.PLU3);
          }
        });

        if (!plu1) {
          console.warn("No se encontró PLU1 en productDataInfo");
          return { tpvs: [] };
        }

        // Crear estructura base del producto desde prodSel
        var productoBase = {
          idProdBusinessCentral: plu1,
          productName:
            prodSel && prodSel.productName ? prodSel.productName : "",
          tipoIVA: prodSel && prodSel.tipoIVA ? prodSel.tipoIVA : "IVA10",
          impuestoPorcentaje: primerIva(prodSel && prodSel.impuestoPorcentaje),
          esProduct: prodSel && prodSel.esProduct ? prodSel.esProduct : true,
          lastDateModifiedBC: new Date().toISOString(),
          tieneSubproducts: udsMedida.size > 1,
          tipoPendiente: "pendienteActualizar",
          fromRatesToFormats:
            prodSel && typeof prodSel.changeFormatToRates !== "undefined"
              ? prodSel.changeFormatToRates
              : 0,
          idNumier:
            prodSel &&
              prodSel.idsNumier &&
              prodSel.idsNumier[0] &&
              prodSel.idsNumier[0].idNumier
              ? prodSel.idsNumier[0].idNumier
              : "",
          udMedida: Array.from(udsMedida),
          idMateriasPrimas:
            prodSel && prodSel.idMateriasPrimas
              ? prodSel.idMateriasPrimas.slice()
              : [],
          MostrarEnListaCON:
            prodSel && prodSel.MostrarEnListaCON
              ? prodSel.MostrarEnListaCON
              : false,
          MostrarEnListaSUPLEMENTO:
            prodSel && prodSel.MostrarEnListaSUPLEMENTO
              ? prodSel.MostrarEnListaSUPLEMENTO
              : false,
        };

        // console.log("productoBase", productoBase);
        // console.log("udsMedida", udsMedida);

        // Procesar datos desde productosNumier
        var productosPorTpv = {};

        // Agrupar productos por TPV desde productDataInfo
        Object.keys(productDataInfo.tpvs).forEach(function (tpvId) {
          if (!productosPorTpv[tpvId]) {
            productosPorTpv[tpvId] = [];
          }
        });

        // Para tarifas, el formulario emite una fila por TPV (idTpvServer) con los precios y la
        // categoría de ese TPV: el mismo código BC puede tener precios y categoría distintos en
        // cada TPV. Se usa la fila del TPV que toca; solo si no la hay se cae a la primera.
        if (productosNumier.length > 0) {
          var itemTarifaPorDefecto = productosNumier[0];

          // Iterar sobre cada TPV desde productDataInfo
          Object.keys(productDataInfo.tpvs).forEach(function (tpvId) {
            var itemTarifa =
              productosNumier.find(function (item) {
                var p = item.producto || item;
                var tpvDelItem = p.idTpvServer !== undefined && p.idTpvServer !== null ? p.idTpvServer : item.idTpvServer;
                return tpvDelItem !== undefined && tpvDelItem !== null && String(tpvDelItem) === String(tpvId);
              }) || itemTarifaPorDefecto;
            var prodTarifa = itemTarifa.producto || itemTarifa;

            var tpvDeLaFilaTarifa = prodTarifa.idTpvServer !== undefined && prodTarifa.idTpvServer !== null
              ? prodTarifa.idTpvServer
              : itemTarifa.idTpvServer;
            var grupoEnlazadoTarifa =
              (tpvDeLaFilaTarifa === undefined || tpvDeLaFilaTarifa === null || String(tpvDeLaFilaTarifa) === String(tpvId))
                ? (prodTarifa.grupo_enlazado || "")
                : "";
            // Detectar número de tarifas activas
            var numPreciosActivos =
              ((prodTarifa.selPrice1 || (prodTarifa.namePrice1 && prodTarifa.namePrice1.trim())) ? 1 : 0) +
              ((prodTarifa.selPrice2 || (prodTarifa.namePrice2 && prodTarifa.namePrice2.trim())) ? 1 : 0) +
              ((prodTarifa.selPrice3 || (prodTarifa.namePrice3 && prodTarifa.namePrice3.trim())) ? 1 : 0) +
              ((prodTarifa.selPrice4 || (prodTarifa.namePrice4 && prodTarifa.namePrice4.trim())) ? 1 : 0);

            var finalPlu2Tarifa = numPreciosActivos > 1 ? "Tarifas" : "Simple";

            var nombreProducto = this.normalizarNombreProducto(
              prodTarifa.nombreProducto || prodTarifa.productName,
              ""
            );

            var productoProcesado = {
              nombreProducto: nombreProducto,
              idProd: this.setIdProd2(
                prodSel,
                tpvId,
                prodTarifa.PLU3 || itemTarifa.unidad || ""
              ),
              codUdMedida: prodTarifa.PLU3 || itemTarifa.unidad || "",
              descripcion: prodTarifa.descripcion || "",
              codigoBarras: prodTarifa.codigoBarras || "",
              idCategory: prodTarifa.idCategory || 0,
              tipoIva: primerIva(prodTarifa.tipoIva, prodTarifa.iva),
              color: prodTarifa.color || "amarillo",
              selPrice1:
                !!(prodTarifa.namePrice1 && prodTarifa.namePrice1.trim()) ||
                (prodTarifa.selPrice1 || false),
              selPrice2:
                !!(prodTarifa.namePrice2 && prodTarifa.namePrice2.trim()) ||
                (prodTarifa.selPrice2 || false),
              selPrice3:
                !!(prodTarifa.namePrice3 && prodTarifa.namePrice3.trim()) ||
                (prodTarifa.selPrice3 || false),
              selPrice4:
                !!(prodTarifa.namePrice4 && prodTarifa.namePrice4.trim()) ||
                (prodTarifa.selPrice4 || false),
              price1: prodTarifa.price1 || 0,
              price2: prodTarifa.price2 || 0,
              price3: prodTarifa.price3 || 0,
              price4: prodTarifa.price4 || 0,
              namePrice1: prodTarifa.namePrice1 || "",
              namePrice2: prodTarifa.namePrice2 || "",
              namePrice3: prodTarifa.namePrice3 || "",
              namePrice4: prodTarifa.namePrice4 || "",
              orden: parseInt(prodTarifa.orden) || 999,
              PLU1: plu1,
              PLU2: finalPlu2Tarifa,
              PLU3: prodTarifa.PLU3 || itemTarifa.unidad || "",
              PLU4: "",
              grupo_enlazado: grupoEnlazadoTarifa,
              active: "1",
            };

            // console.log("Producto tarifa procesado:", productoProcesado);
            productosPorTpv[tpvId].push(this.ajustarCamposPorTipo(productoProcesado));
          }, this);
        }

        // console.log("productosPorTpv", productosPorTpv);

        // Convertir productosPorTpv a tpvGroups
        var tpvGroups = [];
        Object.keys(productosPorTpv).forEach(function (tpvId) {
          tpvGroups.push({
            idTpv: tpvId,
            prods: productosPorTpv[tpvId],
          });
        });

        // console.log("Estructura final normalizada (Tarifas):", {
        //   productBC: productoBase,
        //   tpvs: tpvGroups,
        // });

        if (!productoBase.udMedida.length) {
          productoBase.udMedida = prodSel.udMedida;
        }

        return {
          productBC: productoBase,
          tpvs: tpvGroups,
        };

      } else {
        // Obtener PLU1 desde productDataInfo
        var plu1 = null;
        var udsMedida = new Set();

        if (
          Object.keys(productDataInfo) &&
          Object.keys(productDataInfo.tpvs).length > 0
        ) {

          Object.keys(productDataInfo.tpvs).forEach(function (tpvId) {
            var tpvData = productDataInfo.tpvs[tpvId];

            if (
              tpvData &&
              tpvData.productos &&
              Array.isArray(tpvData.productos)
            ) {
              tpvData.productos.forEach(function (prodWrapper) {
                if (prodWrapper.producto) {
                  var prod = prodWrapper.producto;
                  // console.log("prod", prod);
                  if (!plu1 && prod.PLU1) {
                    plu1 = prod.PLU1;
                  }
                  // QUITADO: No agregar unidades existentes
                }
              });
            }
          });
        }

        // AGREGAR TAMBIÉN LAS UNIDADES NUEVAS DESDE productosNumier
        productosNumier.forEach(function (item) {
          var prod = item.producto || item;
          if (prod.PLU3) {
            udsMedida.add(prod.PLU3);
          }
        });

        if (!plu1) {
          console.warn("No se encontró PLU1 en productDataInfo");
          return { tpvs: [] };
        }

        // Crear estructura base del producto desde prodSel
        var productoBase = {
          idProdBusinessCentral: plu1,
          productName:
            prodSel && prodSel.productName ? prodSel.productName : "",
          tipoIVA: prodSel && prodSel.tipoIVA ? prodSel.tipoIVA : "IVA10",
          impuestoPorcentaje: primerIva(prodSel && prodSel.impuestoPorcentaje),
          esProduct: prodSel && prodSel.esProduct ? prodSel.esProduct : true,
          lastDateModifiedBC: new Date().toISOString(),
          tieneSubproducts: udsMedida.size > 1,
          tipoPendiente: "pendienteActualizar",
          fromRatesToFormats:
            prodSel && typeof prodSel.changeFormatToRates !== "undefined"
              ? prodSel.changeFormatToRates
              : 0,
          idNumier:
            prodSel &&
              prodSel.idsNumier &&
              prodSel.idsNumier[0] &&
              prodSel.idsNumier[0].idNumier
              ? prodSel.idsNumier[0].idNumier
              : "",
          udMedida: Array.from(udsMedida),
          idMateriasPrimas:
            prodSel && prodSel.idMateriasPrimas
              ? prodSel.idMateriasPrimas.slice()
              : [],
          MostrarEnListaCON:
            prodSel && prodSel.MostrarEnListaCON
              ? prodSel.MostrarEnListaCON
              : false,
          MostrarEnListaSUPLEMENTO:
            prodSel && prodSel.MostrarEnListaSUPLEMENTO
              ? prodSel.MostrarEnListaSUPLEMENTO
              : false,
        };


        // Procesar datos desde productosNumier (que vienen del formulario)
        var tpvGroups = [];
        var productosPorTpv = {};

        // Iterar sobre cada item en productosNumier (contiene producto, con, suplemento)
        productosNumier.forEach(function (item) {
          var productoSimple = item.producto || item;
          var productoCon = item.con;
          var productoSuple = item.suplemento;




          //productoSimple.departments = [];
          // Object.entries(productDataInfo.tpvs).forEach(([key, value]) => {
          //   // console.log("Clave:", key);
          //   // console.log("Productos:", value.productos);
          //   productoSimple.departments.push({
          //     id: key,
          //     // nombre: value.nombre,
          //   });
          // });


          // DESPUÉS (preserva los del form si tienen datos, si no hace lo mismo de antes):
          const departmentsDelForm = (productoSimple.departments && productoSimple.departments.length > 0 && productoSimple.departments[0].iva)
            ? [...productoSimple.departments]
            : null;

          productoSimple.departments = [];

          Object.entries(productDataInfo.tpvs).forEach(([key, value]) => {
            // Si tenemos departments del form con datos, buscar el que corresponde a este TPV
            const deptDelForm = departmentsDelForm
              ? departmentsDelForm.find(d => String(d.id) === String(key))
              : null;

            productoSimple.departments.push(deptDelForm || { id: key });
          });

          // Procesar PRODUCTO SIMPLE
          if (productoSimple && productoSimple.departments) {
            // console.log("productoSimple", productoSimple);
            productoSimple.departments.forEach(function (dept) {
              var tpvId = dept.id;

              // De-duplicación: Solo añadir el producto al TPV que le corresponde
              if (productoSimple.idTpvServer && String(productoSimple.idTpvServer) !== String(tpvId)) {
                return;
              }

              if (!productosPorTpv[tpvId]) {
                productosPorTpv[tpvId] = [];
              }

              var nombreProducto = this.normalizarNombreProducto(
                productoSimple.nombreProducto || productoSimple.productName,
                ""
              );

              // Detectar si este producto específico es Tarifas o Simple
              var numPreciosActivos =
                ((productoSimple && (productoSimple.selPrice1 || (productoSimple.namePrice1 && productoSimple.namePrice1.trim()))) ? 1 : 0) +
                ((productoSimple && (productoSimple.selPrice2 || (productoSimple.namePrice2 && productoSimple.namePrice2.trim()))) ? 1 : 0) +
                ((productoSimple && (productoSimple.selPrice3 || (productoSimple.namePrice3 && productoSimple.namePrice3.trim()))) ? 1 : 0) +
                ((productoSimple && (productoSimple.selPrice4 || (productoSimple.namePrice4 && productoSimple.namePrice4.trim()))) ? 1 : 0);

              var finalPlu2Tarifa = numPreciosActivos > 1 ? "Tarifas" : "Simple";

              var productoProcesado = {
                nombreProducto: nombreProducto,
                idProd: this.setIdProd2(
                  prodSel,
                  tpvId,
                  productoSimple.PLU3 || item.unidad || ""
                ),
                codUdMedida: productoSimple.PLU3 || item.unidad || "",
                descripcion: productoSimple.descripcion || "",
                codigoBarras: productoSimple.codigoBarras || "",
                idCategory:
                  (dept.categoria && dept.categoria.id) ||
                  productoSimple.idCategory ||
                  0,
                tipoIva: primerIva(dept.iva, productoSimple.iva),
                color: productoSimple.color || "amarillo",
                selPrice1: productoSimple.selPrice1 || false,
                selPrice2: productoSimple.selPrice2 || false,
                selPrice3: productoSimple.selPrice3 || false,
                selPrice4: productoSimple.selPrice4 || false,
                active: productoSimple.isActive !== undefined ? (productoSimple.isActive ? 1 : 0) : 1,
                price1: dept.price1 || productoSimple.price1 || 0,
                price2: dept.price2 || productoSimple.price2 || 0,
                price3: dept.price3 || productoSimple.price3 || 0,
                price4: dept.price4 || productoSimple.price4 || 0,
                namePrice1: productoSimple.namePrice1 || "",
                namePrice2: productoSimple.namePrice2 || "",
                namePrice3: productoSimple.namePrice3 || "",
                namePrice4: productoSimple.namePrice4 || "",
                orden: parseInt(productoSimple.orden) || 999,
                PLU1: plu1,
                PLU2: finalPlu2Tarifa,
                PLU3: productoSimple.PLU3 || item.unidad || "",
                PLU4: "",
                grupo_enlazado: productoSimple.grupo_enlazado || "",
              };

              productosPorTpv[tpvId].push(this.ajustarCamposPorTipo(productoProcesado));
            }, this);
          }

          // Procesar PRODUCTO CON-SUPLEMENTO
          if (productoCon && productoCon.departments) {
            productoCon.departments.forEach(function (dept) {
              var tpvId = dept.id;

              // De-duplicación: Solo añadir el producto al TPV que le corresponde
              if (productoCon.idTpvServer && String(productoCon.idTpvServer) !== String(tpvId)) {
                return;
              }

              if (!productosPorTpv[tpvId]) {
                productosPorTpv[tpvId] = [];
              }

              var nombreProducto = this.normalizarNombreProducto(
                productoCon.nombreProducto || productoCon.productName,
                "CON"
              );

              var productoProcesado = {
                nombreProducto: nombreProducto,
                idProd: this.setIdProd(
                  prodSel,
                  nombreProducto,
                  tpvId,
                  productDataInfo,
                  "CON"
                ),
                codUdMedida: "",
                descripcion: productoCon.descripcion || "",
                codigoBarras: productoCon.codigoBarras || "",
                idCategory: productoCon.idCategory || 0,
                tipoIva: parseFloat(productoCon.iva) || 0,
                color: productoCon.color || "rojo",
                selPrice1: productoCon.selPrice1 || false,
                selPrice2: productoCon.selPrice2 || false,
                selPrice3: productoCon.selPrice3 || false,
                selPrice4: productoCon.selPrice4 || false,
                price1: productoCon.price1 || 0,
                price2: productoCon.price2 || 0,
                price3: productoCon.price3 || 0,
                price4: productoCon.price4 || 0,
                namePrice1: productoCon.namePrice1 || "",
                namePrice2: productoCon.namePrice2 || "",
                namePrice3: productoCon.namePrice3 || "",
                namePrice4: productoCon.namePrice4 || "",
                orden: parseInt(productoCon.orden) || 999,
                PLU1: plu1,
                PLU2: "CON-SUPLEMENTO",
                PLU3: "CON",
                PLU4: "",
                grupo_enlazado: "",
              };

              productosPorTpv[tpvId].push(this.ajustarCamposPorTipo(productoProcesado));
            }, this);
          }

          // Procesar PRODUCTO SUPLEMENTO
          if (productoSuple && productoSuple.departments) {
            productoSuple.departments.forEach(function (dept) {
              var tpvId = dept.id;

              // De-duplicación: Solo añadir el producto al TPV que le corresponde
              if (productoSuple.idTpvServer && String(productoSuple.idTpvServer) !== String(tpvId)) {
                return;
              }

              if (!productosPorTpv[tpvId]) {
                productosPorTpv[tpvId] = [];
              }

              var nombreProducto = this.normalizarNombreProducto(
                productoSuple.nombreProducto || productoSuple.productName,
                "SUPLE"
              );

              var productoProcesado = {
                nombreProducto: nombreProducto,
                idProd: this.setIdProd(
                  prodSel,
                  nombreProducto,
                  tpvId,
                  productDataInfo,
                  "SUPLEMENTO"
                ),
                codUdMedida: "",
                descripcion: productoSuple.descripcion || "",
                codigoBarras: productoSuple.codigoBarras || "",
                idCategory: productoSuple.idCategory || 0,
                tipoIva: isNaN(parseFloat(productoSuple.iva)) ? 21 : parseFloat(productoSuple.iva),
                color: productoSuple.color || "amarillo",
                selPrice1: productoSuple.selPrice1 || false,
                selPrice2: productoSuple.selPrice2 || false,
                selPrice3: productoSuple.selPrice3 || false,
                selPrice4: productoSuple.selPrice4 || false,
                price1: productoSuple.price1 || 0,
                price2: productoSuple.price2 || 0,
                price3: productoSuple.price3 || 0,
                price4: productoSuple.price4 || 0,
                namePrice1: productoSuple.namePrice1 || "",
                namePrice2: productoSuple.namePrice2 || "",
                namePrice3: productoSuple.namePrice3 || "",
                namePrice4: productoSuple.namePrice4 || "",
                orden: parseInt(productoSuple.orden) || 999,
                PLU1: plu1,
                PLU2: "SUPLEMENTO",
                PLU3: "SUPLE",
                PLU4: "",
                grupo_enlazado: "",
                variacionPrecio: productoSuple.variacionPrecio || 0,
              };

              productosPorTpv[tpvId].push(this.ajustarCamposPorTipo(productoProcesado));
            }, this);
          }
        }, this);

        // Convertir productosPorTpv a tpvGroups
        Object.keys(productosPorTpv).forEach(function (tpvId) {
          tpvGroups.push({
            idTpv: tpvId,
            prods: productosPorTpv[tpvId],
          });
        });

        // Para productos Simple sin PLU3, buscar PLU4 en los productos del TPV
        if (!productoBase.udMedida.length && tpvGroups.length > 0) {
          // Buscar el primer producto Simple con PLU4 definido
          let plu4Encontrado = null;
          for (let i = 0; i < tpvGroups.length && !plu4Encontrado; i++) {
            const prods = tpvGroups[i].prods || [];
            for (let j = 0; j < prods.length && !plu4Encontrado; j++) {
              if (prods[j].PLU2 === "Simple" && prods[j].PLU4) {
                plu4Encontrado = prods[j].PLU4;
                // console.log("[BC] Producto Simple detectado. Usando PLU4 como udMedida:", plu4Encontrado);
              }
            }
          }

          if (plu4Encontrado) {
            productoBase.udMedida = [plu4Encontrado];
            productoBase.tieneSubproducts = false;
          } else {
            // Fallback original solo si no es un producto Simple con PLU4
            productoBase.udMedida = prodSel.udMedida;
          }
        }

        return {
          productBC: productoBase,
          tpvs: tpvGroups,
        };
      }
    },

    normalizarNombreProducto: function (nombre, plu3) {
      if (!nombre || !plu3) return nombre || "";

      // Eliminar TODAS las ocurrencias de PLU3 del nombre
      var nombreLimpio = nombre.trim();
      var nombreSinPLU3 = nombreLimpio
        .replace(new RegExp(plu3, "g"), "")
        .trim();

      // Limpiar espacios múltiples que pudieron quedar
      nombreSinPLU3 = nombreSinPLU3.replace(/\s+/g, " ").trim();

      // Añadir PLU3 una sola vez al final
      return nombreSinPLU3 + " " + plu3;
    },

    normalizarNombreBase: function (nombre) {
      if (!nombre) return "";
      var partes = nombre.split(" ");
      if (partes.length <= 2) return nombre; // Ej: "COCA COLA", "PEPSI"
      return partes.slice(0, partes.length - 2).join(" ");
    },

    // Busca en un TPV el producto CON / SUPLEMENTO que ya existe en Numier.
    // Primero por la marca de tipo (PLU2 = 'CON-SUPLEMENTO' y PLU3 = 'CON' | 'SUPLEMENTO'), que es
    // como los crea la API; el nombre solo se usa como fallback (los CON/SUPL de Numier se
    // llaman igual que el base, así que el nombre no distingue el tipo).
    buscarProductoExistente: function (nombreProducto, idTpv, productDataInfo, plu3Marca) {
      var tpvInfo = this.getTpvInfo(idTpv, productDataInfo);
      if (!tpvInfo || !Array.isArray(tpvInfo.prods)) return null;

      var lista = tpvInfo.prods;
      var marca = String(plu3Marca || "").trim().toUpperCase();

      if (marca) {
        for (var i = 0; i < lista.length; i++) {
          var p = lista[i];
          if (!p) continue;
          if (String(p.PLU2 || "").trim().toUpperCase() === "CON-SUPLEMENTO" &&
            String(p.PLU3 || "").trim().toUpperCase() === marca) {
            return p;
          }
        }
      }

      var target = (nombreProducto || "").trim().toUpperCase();
      if (!target) return null;

      for (var j = 0; j < lista.length; j++) {
        var prod = lista[j];
        if (!prod) continue;
        var nombre = prod.nombreProducto || prod.name || "";
        if (nombre.trim().toUpperCase() === target) {
          return prod;
        }
      }
      return null;
    },

    productoYaExiste: function (nombreProducto, idTpv, productDataInfo, plu3Marca) {
      return !!this.buscarProductoExistente(nombreProducto, idTpv, productDataInfo, plu3Marca);
    },

    // idProd de la fila CON / SUPLEMENTO de un TPV: el id Numier del producto que ya existe en
    // ese TPV, o "" si todavía no existe (antes devolvía el código BC, que no es un id de producto).
    setIdProd: function (prodSel, nombreProducto, idTpv, productDataInfo, plu3Marca) {
      var baseName = this.normalizarNombreBase(nombreProducto || "");

      // No coincide con BC → ""
      if (
        !prodSel ||
        prodSel.productName.trim().toUpperCase() !==
        baseName.trim().toUpperCase()
      ) {
        return "";
      }

      var existente = this.buscarProductoExistente(nombreProducto, idTpv, productDataInfo, plu3Marca);
      if (existente && existente.id !== undefined && existente.id !== null && String(existente.id) !== "") {
        return String(existente.id);
      }

      return "";
    },


    // Devuelve el idNumier del producto ya existente en Numier para un TPV y una unidad.
    // La API devuelve `idTpv` en cada elemento de idsNumier: se busca por idTpv + codUdMedida.
    // La resolución por posición del TPV solo se mantiene como fallback para payloads antiguos sin idTpv.
    setIdProd2: function (prodSel, tpvId, codUdMedida) {
      if (!prodSel || !Array.isArray(prodSel.idsNumier) || prodSel.idsNumier.length === 0) {
        return "";
      }

      const unitToMatch = String(codUdMedida || "").trim().toUpperCase();
      const tpvToMatch = String(tpvId || "").trim();
      const tieneIdTpv = prodSel.idsNumier.some(
        item => item && item.idTpv !== undefined && item.idTpv !== null && String(item.idTpv) !== ""
      );

      // 0. Con idTpv en el payload: acotar primero al TPV de la fila.
      //    Un producto de otro TPV nunca es candidato, aunque comparta unidad.
      const idsDelTpv = tieneIdTpv
        ? prodSel.idsNumier.filter(item => item && String(item.idTpv) === tpvToMatch)
        : prodSel.idsNumier;

      if (tieneIdTpv && idsDelTpv.length === 0) {
        return "";
      }

      // 1. Filtrar por unidad de medida (Normalizado)
      const candidatos = idsDelTpv.filter(item => {
        const itemUnit = String(item.codUdMedida || "").trim().toUpperCase();
        return itemUnit === unitToMatch;
      });

      if (candidatos.length === 1) {
        return candidatos[0].idNumier;
      }

      if (candidatos.length > 1) {
        if (tieneIdTpv) {
          // Para formatos repetidos
          const activo = candidatos.find(item => String(item.active) === "1");
          return activo ? activo.idNumier : candidatos[0].idNumier;
        }
        // FALLBACK payload antiguo sin idTpv: resolver por posición del TPV entre los candidatos
        const tpvIndex = this.selectedTpvServerList.findIndex(
          tpv => String(tpv.idTpvServer) === String(tpvId)
        );
        return candidatos[tpvIndex] ? candidatos[tpvIndex].idNumier : candidatos[0].idNumier;
      }

      // 2. FALLBACK: Si solo hay un producto en Numier (para este TPV) y estamos expandiendo a formatos,
      // probablemente sea el mismo producto aunque la unidad no coincida exactamente (ej: de "UNID" a "TAPA").
      if (idsDelTpv.length === 1) {
        const item = idsDelTpv[0];
        const itemUnit = String(item.codUdMedida || "").trim().toUpperCase();

        // Si la unidad del producto existente es genérica o vacía, la mapeamos al primer formato nuevo
        const isGenericUnit = itemUnit === "" || itemUnit === "UNID" || itemUnit === "UNIDAD" || itemUnit === "PCS";
        const isFirstFormat = prodSel.udMedida && prodSel.udMedida[0] === codUdMedida;

        if (isGenericUnit && isFirstFormat) {
          return item.idNumier;
        }

        // Si es el primer formato y el único ID existente, lo reutilizamos para evitar duplicados
        if (isFirstFormat) {
          return item.idNumier;
        }
      }

      return "";
    },


    // Devuelve { idTpv, prods: [...] } con los productos que ya existen en Numier para ese TPV.
    // La API (products/getProductDataInfo) devuelve `tpvs` como OBJETO indexado por idTpv:
    //   { "<idTpv>": { productos: [ { producto: {...fila de products...}, subproductos: [...] } ] } }
    // Se mantiene como fallback la forma antigua en array [{ idTpv, prods }].
    getTpvInfo: function (idTpv, productDataInfo) {
      if (!productDataInfo || !productDataInfo.tpvs) return null;

      var tpvs = productDataInfo.tpvs;

      if (Array.isArray(tpvs)) {
        for (var i = 0; i < tpvs.length; i++) {
          if (tpvs[i] && String(tpvs[i].idTpv) === String(idTpv)) {
            return tpvs[i];
          }
        }
        return null;
      }

      var tpvData = tpvs[String(idTpv)] || tpvs[idTpv];
      if (!tpvData) return null;

      var lista = Array.isArray(tpvData.productos) ? tpvData.productos : (Array.isArray(tpvData.prods) ? tpvData.prods : []);

      return {
        idTpv: idTpv,
        prods: lista.map(function (pw) { return pw && pw.producto ? pw.producto : pw; }).filter(Boolean),
      };
    },

    /**
     * Actualiza automáticamente la tipología de un producto (CON / SUPLEMENTO)
     * en función de los cambios recibidos desde Business Central.
     *
     * Este endpoint no ejecuta directamente la mutación completa del producto,
     * sino que devuelve un conjunto de flags tipificados que describen
     * exactamente qué tipo de cambio debe aplicarse en el frontend.
     *
     * Los flags permiten al flujo decidir si:
     * - El cambio puede aplicarse de forma transparente
     * - Debe mostrarse una advertencia al usuario
     * - Es necesario redirigir al formulario completo de edición
     * - La transmutación es inválida y debe bloquearse
     *
     * **Casuísticas soportadas**
     *
     * 1. Productos que YA admitían CON y/o SUPLEMENTO
     *
     *   1.1 Intercambio de tipo (swap)
     *   - Antes solo CON, ahora solo SUPLEMENTO
     *     → `type_swap_con_to_suple`
     *
     *   - Antes solo SUPLEMENTO, ahora solo CON
     *     → `type_swap_suple_to_con`
     *
     *   1.2 Paso de uno a ambos
     *   - Antes solo CON, ahora CON + SUPLEMENTO
     *     → `type_add_suple`
     *
     *   - Antes solo SUPLEMENTO, ahora CON + SUPLEMENTO
     *     → `type_add_con`
     *
     *   1.3 Paso de ambos a uno solo
     *   - Antes CON + SUPLEMENTO, ahora solo CON
     *     → `type_remove_suple`
     *
     *   - Antes CON + SUPLEMENTO, ahora solo SUPLEMENTO
     *     → `type_remove_con`
     *
     *   1.4 Eliminación completa
     *   - Antes admitía CON y/o SUPLEMENTO, ahora ninguno
     *     → `type_remove_all_con_suple`
     *
     * 2. Productos que NO eran CON / SUPLEMENTO y ahora sí
     *
     *   - Producto normal → solo CON
     *     → `type_new_con`
     *
     *   - Producto normal → solo SUPLEMENTO
     *     → `type_new_suple`
     *
     *   - Producto normal → CON + SUPLEMENTO
     *     → `type_new_con_suple`
     *
     * **Flags globales**
     *
     * - `type_invalid_transmutation`: El producto no puede transformarse
     *   (tarifas, configuración inválida, etc.)
     *
     * - `requires_full_form`: El producto debe editarse desde el formulario
     *   completo
     *
     * - `transparent_update`: El cambio puede aplicarse de forma automática y
     *   silenciosa
     *
     * @returns {Object} flags
     * @returns {boolean} flags.type_swap_con_to_suple
     * @returns {boolean} flags.type_swap_suple_to_con
     * @returns {boolean} flags.type_add_suple
     * @returns {boolean} flags.type_add_con
     * @returns {boolean} flags.type_remove_suple
     * @returns {boolean} flags.type_remove_con
     * @returns {boolean} flags.type_remove_all_con_suple
     * @returns {boolean} flags.type_new_con
     * @returns {boolean} flags.type_new_suple
     * @returns {boolean} flags.type_new_con_suple
     * @returns {boolean} flags.type_invalid_transmutation
     * @returns {boolean} flags.requires_full_form
     * @returns {boolean} flags.transparent_update
     */
    updateProductTypeFlags() {
      const p = this.productoSeleccionado;
      console.log(p);
      if (
        !p ||
        (!p.MostrarEnListaCON && !p.MostrarEnListaSUPLEMENTO) ||
        !p.flags.requires_full_form
      ) {
        return;
      }

      const flags = p.flags || {};
      
      console.log(flags);

      this.productTypeFlags = {
        type_swap_con_to_suple: flags.type_swap_con_to_suple || false,
        type_swap_suple_to_con: flags.type_swap_suple_to_con || false,
        type_add_suple: flags.type_add_suple || false,
        type_add_con: flags.type_add_con || false,
        type_remove_suple: flags.type_remove_suple || false,
        type_remove_con: flags.type_remove_con || false,
        type_remove_all_con_suple: flags.type_remove_all_con_suple || false,
        type_new_con: flags.type_new_con || false,
        type_new_suple: flags.type_new_suple || false,
        type_new_con_suple: flags.type_new_con_suple || false,
        type_invalid_transmutation: flags.type_invalid_transmutation || false,
        requires_full_form: flags.requires_full_form || false,
        transparent_update: flags.transparent_update || false,
      };

      // Para pedir la variación de precio (no entrará en form ninguno)
      this.requiresSuplePriceModal =
        !flags.type_invalid_transmutation &&
        !flags.transparent_update &&
        (flags.type_add_suple === true || flags.type_new_suple === true);
    },

    resetSupplementPrice() {
      this.suplementPrice = 0;
    },

    openSupplementPriceModal() {
      this.$modal.show("supplement-price-modal");
    },

    closeSupplementPriceModal() {
      this.suplementPrice = 0;
      this.$modal.hide("supplement-price-modal");
    },

    saveSupplementPrice() {
      // if (!this.productDataInfo || !this.productDataInfo.tpvs) return;
      // console.log("SUPLEMENTO: ", this.suplementPrice);

      const tpvs = this.productDataInfo.tpvs;

      // Un objeto por TPV
      this.priceVariationsByTpv = Object.keys(tpvs).map((idTpv) => ({
        idTpv: idTpv,
        variation: this.suplementPrice,
      }));

      // console.log(this.priceVariationsByTpv);
      this.closeSupplementPriceModal();
      this.editProductAdvanced();
    },

    editProductAdvanced() {
      // console.log("Aquí guardo el precio del suple");
      // console.log("SUPLEMENTO VALUE: ", this.suplementPrice);

      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
        priceVariations: this.priceVariationsByTpv,
        idBusinessCentral: this.productoSeleccionado.idProdBusinessCentral,
        flags: this.productTypeFlags,
      };

      this.axios
        .post(
          this.$store.getters.apiUrl + "businesscentral/editProductAdvanced",
          params,
          config
        )
        .then((response) => {
          // TO-DO: Pendiente de saber qué respuesta me devolverá el back
          if (
            (response.data &&
              response.data.editedIds &&
              response.data.editedIds.length > 0) ||
            (response.data && response.data.response)
          ) {
            if (this.loadingGeneral) this.loadingGeneral.close();

            // Eliminar el producto actualizado de productosPendientes usando idProdBusinessCentral
            if (
              this.productoSeleccionado &&
              this.productoSeleccionado.idProdBusinessCentral
            ) {
              const updatedProductId =
                this.productoSeleccionado.idProdBusinessCentral;

              // Eliminar solo el producto que se acaba de actualizar
              this.productosPendientes = this.productosPendientes.filter(
                (p) => p.idProdBusinessCentral !== updatedProductId
              );

              // Resetear la página actual para asegurar que la UI se actualice
              this.currentPage = 1;
            }

            Swal.fire({
              title: this.$t("swalProductoSincronizadoTitle"),
              text:
                this.productosPendientes.length > 0
                  ? this.$t("swalProductoSincronizadoTextNPendientes")
                  : this.$t("swalProductoSincronizadoText0Pendientes"),
              type: "success",
              showCancelButton: this.productosPendientes.length > 0,
              cancelButtonText: this.$t(
                "swalProductoSincronizadoButtonTerminar"
              ),
              confirmButtonText: this.$t(
                "swalProductoSincronizadoButtonSeguir"
              ),
              buttonsStyling: true,
              cancelButtonClass: "btn btn-primary btn-fill",
              cancelButtonColor: "#1a73e8",
              confirmButtonClass:
                "btn btn-outline-primary btn-fill swal2-cancel-btn",
              confirmButtonColor: "#aaaaaa",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then((result) => {
              if (result.value) {
                this.shouldRedirect = true;
              }
            });
          } else {
            console.warn("No se pudieron editar productos.");
            if (this.loadingGeneral) this.loadingGeneral.close();
            Swal.fire({
              title: this.$t("error"),
              text: this.$t("serverError"),
              type: "error",
              confirmButtonText: this.$t("vale"),
            });
          }
        })
        .catch((error) => {
          console.error("Error al editar productos:", error.message);
        });
    },

    // Llama al endpoint interno `products/getProductosFromBusinessCentral` que obtiene el accessToken desde Azure AD y consulta la lista de productos vía Business Central API.
    // Si la respuesta es correcta, asigna los productos a `productosPendientesFromBusinessCentral`.
    // **El método tiene un parámetro que por defecto es true a menos que le pasemos false al llamarlo. Es para SÍ mostrar el cargando en el step1 al cargar los productos y para
    // NO mostrarlo en el step3 cuando se ha sincronizado un producto y estamos consultando si hay más productos pendientes de sincronizar.
    getProductosFromBusinessCentral(mostrarLoading = true) {
      // console.log(" > Solicitando accessToken a Business Central...");
      // console.log(" > El valor de mostrarLoading es ", mostrarLoading);

      if (mostrarLoading) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      }

      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
      };

      return this.axios
        .post(
          this.$store.getters.apiUrl +
          "products/getProductosFromBusinessCentral",
          params,
          config
        )
        .then((response) => {
          if (response.data.response) {
            this.productosPendientes = response.data.productos || [];
            // console.log(" > Lista de productosPendientes cargada desde Business Central:", JSON.parse(JSON.stringify(this.productosPendientes)));
          } else {
            // console.error("Falló la obtención del token:", response.data.message);
            Swal.fire({
              title: this.$t("error"),
              text: response.data.message,
              type: "error",
              confirmButtonText: this.$t("vale"),
            });
          }
        })
        .catch((error) => {
          // console.error("Error al obtener token:", error.message);
          Swal.fire({
            title: this.$t("error"),
            text: this.$t("serverError"),
            type: "error",
            confirmButtonText: this.$t("vale"),
          });
          if (mostrarLoading && this.loadingGeneral) {
            this.loadingGeneral.close();
          }
        });
    },

    getSubproductsNumierBySubproductsBusinessCentral() {
      // console.log(" > Llamando a Relaciones Subproducts Numier ↔ Business Central");

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      return this.axios
        .get(
          this.$store.getters.apiUrl +
          "subproducts/getSubproductsNumierBySubproductsBusinessCentral",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.subproductsNumierByBusinessCentral = response.data.result || [];
            // console.log(" > Relaciones Subproducts Numier ↔ Business Central:", response.data.result);
          }
        })
        .catch(function (error) {
          console.error("Error al obtener relaciones de subproductos:", error);
        });
    },

    async seleccionarProducto(producto, isCreating = false) {
      // console.log("Seleccionar producto: ", producto.udMedida);

      // Verificar si el producto tiene unidad de medida
      if (
        !producto.udMedida ||
        !Array.isArray(producto.udMedida) ||
        producto.udMedida.length === 0
      ) {
        Swal.fire({
          title: this.$t("error"),
          text: this.$t("errorUnidadMedidaNoConfigurada"),
          type: "error",
          confirmButtonText: this.$t("vale"),
        });
        return;
      }

      if (
        producto.udMedida.length > 1 &&
        (producto.MostrarEnListaCON || producto.MostrarEnListaSUPLEMENTO)
      ) {
        Swal.fire({
          title: this.$t("error"),
          text: this.$t("errorVariasUdsMedidasProductoConSuplemento"),
          type: "error",
          confirmButtonText: this.$t("vale"),
        });
        return;
      }

      // Buscar todas las líneas de receta para este producto
      const lineasReceta = this.recetasFromBusinessCentral.filter(
        (r) => r.idRecetaBusinessCentral === producto.idProdBusinessCentral
      );
      // console.log("Líneas de receta encontradas:", lineasReceta);

      // Verificar si hay materias primas sin unidad de medida
      // (solo aplica en alta de producto nuevo, no en edición)
      if (
        producto.tipoPendiente !== "pendienteActualizar" &&
        lineasReceta &&
        lineasReceta.length > 0
      ) {
        const materiasSinUdMedida = lineasReceta.filter(
          (linea) =>
            !linea.udMedidaMateriaPrima ||
            linea.udMedidaMateriaPrima.trim() === ""
        );

        if (materiasSinUdMedida.length > 0) {
          // console.log(
          //   "Materias primas sin unidad de medida:",
          //   materiasSinUdMedida
          // );
          const materiasNombres = materiasSinUdMedida
            .map((m) => m.nombreMateriaPrima)
            .join(", ");

          Swal.fire({
            title: this.$t("error"),
            html: `${this.$t(
              "errorUnidadMedidaMateriasPrimas"
            )}: <strong>${materiasNombres}</strong>`,
            type: "error",
            confirmButtonText: this.$t("vale"),
          });
          return;
        }
      }

      const receta = this.recetasFromBusinessCentral.find(
        (r) => r.idRecetaBusinessCentral === producto.idProdBusinessCentral
      );

      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      // Antes MostrarEnListaCON/SUPLEMENTO solo salian de la receta, y un producto SIN receta
      // (tieneSubproducts: false) nunca tiene entrada en recetasFromBusinessCentral, asi que
      // siempre quedaban en false aunque el propio producto ya trajera el valor real desde el
      // backend (producto.mostrarEnListaCON / mostrarEnListaSUPLEMENTO). Se usa ese valor primero,
      // y la receta solo como fallback si el producto no lo trae.
      this.productoSeleccionado = {
        ...producto,
        MostrarEnListaCON: !!(
          typeof producto.mostrarEnListaCON !== "undefined"
            ? producto.mostrarEnListaCON
            : receta
              ? receta.mostrarEnListaCON
              : false
        ),
        MostrarEnListaSUPLEMENTO: !!(
          typeof producto.mostrarEnListaSUPLEMENTO !== "undefined"
            ? producto.mostrarEnListaSUPLEMENTO
            : receta
              ? receta.mostrarEnListaSUPLEMENTO
              : false
        ),
      };


      this.eraSimpleAntesFlag =
        Array.isArray(this.productoSeleccionado.idsNumier) &&
        this.productoSeleccionado.idsNumier.length > 0 &&
        this.productoSeleccionado.idsNumier.every(
          (n) => !n.tipoFormato || n.tipoFormato === "Simple"
        );
      // console.log("El index del producto es ", productoIndex);

      // console.log('Producto seleccionado con flags de receta:', {
      //   idProdBusinessCentral: producto.idProdBusinessCentral,
      //   mostrarEnListaCON: this.productoSeleccionado.MostrarEnListaCON,
      //   mostrarEnListaSUPLEMENTO: this.productoSeleccionado.MostrarEnListaSUPLEMENTO,
      //   recetaEncontrada: !!receta
      // });

      if ("pendienteSincronizar" === this.productoSeleccionado.tipoPendiente) {
        // console.log(" > Reset de productosPorTpvRecuperados porque es pendienteSincronizar");
        this.productosPorTpvRecuperados = [];
        this.moveStep(2);
        // console.log("Movimiento al step2");
        if (isCreating) {
          this.loadingGeneral.close();
        }
      } else if (
        this.productoSeleccionado.tipoPendiente === "pendienteActualizar"
      ) {
        // console.log(this.productoSeleccionado);
        // console.log("Entra al actualizar");
        // console.log(this.productoSeleccionado.goToStepper);
        // console.log(this.productoSeleccionado.udMedida.length);
        // console.log(this.productoSeleccionado.idsNumier[0].tipoFormato);

        if (
          this.productoSeleccionado.goToStepper === 1 &&
          this.productoSeleccionado.udMedida.length > 1 &&
          this.productoSeleccionado.idsNumier[0].tipoFormato === "Formatos"
          // this.productoSeleccionado.idsNumier.some(function (plu) {
          //   return plu.tipoFormato === "Formatos";
          // })
        ) {
          this.crearMultiplesProductosByUdsMedida = true;
        }

        console.log("Antes");
        // Actualizar las flags antes de consultar si debemos abrir el modal
        await this.updateProductTypeFlags();
        
        console.log("Despues");

        // Caso para CON/SUPLE → Será derivado a actualizarse en el formulario de producto completo
        if (
          this.productoSeleccionado.flags &&
          this.productoSeleccionado.flags.requires_full_form
        ) {
          console.log("Update type 1");

          // No le dejamos seguir si el producto no es válido para poder convertirse
          if (this.productoSeleccionado.flags.type_invalid_transmutation) {
            this.loadingGeneral.close();

            Swal.fire({
              title: this.$t("atencion"),
              text: this.$t("noEsProductoValidoParaMutarProductoConSuple"),
              type: "warning",
              confirmButtonText: this.$t("vale"),
            });
          } else if (this.productoSeleccionado.flags.transparent_update) {
            // console.log("No dejar pasar al formulario - Actualización auto");
            this.saveAdvancedProductTransparent();
            console.log("Update type 2");
          } else if (this.requiresSuplePriceModal) {
            // Producto pasa a tener SUPLEMENTO → pedir variación de precio
            if (this.loadingGeneral) {
              this.loadingGeneral.close();
            }
            console.log("Update type 3");
            await this.getSpecialProductDataInfo(
              this.productoSeleccionado.idProdBusinessCentral,
              false
            );
            this.openSupplementPriceModal();
          } else {
            console.log("Update type 4");
            this.getSpecialProductDataInfo(
              this.productoSeleccionado.idProdBusinessCentral,
              true
            );
          }
        }
        // Caso de que debe pasar por el stepper (hay nueva unidad de medida, etc)
        else if (
          this.productoSeleccionado.goToStepper === 1 ||
          this.productoSeleccionado.changeFormatToRates === 1
        ) {
          // console.log("Update type 2");
          this.getProductDataInfo(
            this.productoSeleccionado.idProdBusinessCentral,
            this.productoSeleccionado.changeFormatToRates
          );
        } else {
          try {
            const idProductsNumier = this.productoSeleccionado.idsNumier;

            // console.log("Antes del getData");

            // // Obtener aqui los datos de la categoria
            // this.getDataFromProducts(true);

            // console.log("Despues del getData");

            // Obtener los departamentos activos y espero la respuesta
            this.getActiveDepartmentsFromTpvServerList(idProductsNumier)
              .then((activeDepartments) => {
                // Actualizar los departamentos seleccionados
                if (activeDepartments && activeDepartments.length > 0) {
                  this.selectedTpvServerList = activeDepartments.map(
                    (department) => department.businessName
                  );
                  this.selectedTpvServerNameList = [
                    ...this.selectedTpvServerList,
                  ];
                  this.syncSelectedTpvServers();
                  this.updateSelectAllTpvStatus();

                  this.editProducts();
                }
              })
              .catch((error) => {
                console.error("Error al cargar departamentos activos:", error);
                this.loadingGeneral.close();
              });
          } catch (error) {
            console.error("Error en seleccionarProducto:", error);
            this.loadingGeneral.close();
          }
        }
      }
    },

    updateProgressBar() {
      const firstStepEl = this.$refs["step-1"];
      const currentStepEl = this.$refs[`step-${this.currentStep}`];

      if (firstStepEl && currentStepEl) {
        const firstRect = firstStepEl.getBoundingClientRect();
        const currentRect = currentStepEl.getBoundingClientRect();
        const width = currentRect.left - firstRect.left + currentRect.width / 2;
        this.progressWidth = `${width}px`;
      } else {
        this.progressWidth = "0px";
      }
    },

    setStepRef(el) {
      if (el) {
        const stepNumber = parseInt(el.dataset.step, 10);
        this.$refs[`step-${stepNumber}`] = el;
      }
    },

    moveStep(stepNumber) {
      // console.log(" > En moveStep con stepNumber", stepNumber);

      // Resetear la asignación de categoría
      if (stepNumber === 1) {
        this.productDataInfo = {};
      }

      // console.log("moveStep", this.selectedTpvServerList);
      if (this.productoSeleccionado) {
        // Comprobamos si vamos a pasar al Step 3
        // Detectar si el producto YA es Tarifa o Formato en Numier (por PLU2 en los datos del TPV)
        var yaEsMultiUnidadEnNumier = false;
        if (this.productDataInfo && this.productDataInfo.tpvs) {
          var tpvsKeys = Object.keys(this.productDataInfo.tpvs);
          for (var t = 0; t < tpvsKeys.length; t++) {
            var tpv = this.productDataInfo.tpvs[tpvsKeys[t]];
            if (tpv.productos && Array.isArray(tpv.productos)) {
              for (var p = 0; p < tpv.productos.length; p++) {
                var prod = tpv.productos[p].producto;
                if (prod && (prod.PLU2 === "Tarifas" || prod.PLU2 === "Formatos")) {
                  yaEsMultiUnidadEnNumier = true;
                  break;
                }
              }
            }
            if (yaEsMultiUnidadEnNumier) break;
          }
        }

        // Producto nuevo = pendienteSincronizar con idsNumier vacío
        var esProductoNuevo =
          this.productoSeleccionado.tipoPendiente === "pendienteSincronizar" &&
          (!this.productoSeleccionado.idsNumier || this.productoSeleccionado.idsNumier.length === 0);

        if (
          stepNumber === 3 &&
          this.productoSeleccionado.udMedida.length > 1 &&
          !this.udMedidaChoiceMade &&
          !this.productoSeleccionado.MostrarEnListaCON &&
          !this.productoSeleccionado.MostrarEnListaSUPLEMENTO &&
          !yaEsMultiUnidadEnNumier &&
          (this.eraSimpleAntesFlag || esProductoNuevo)
        ) {
          // console.log("Soy A - Mostrando modal de elección de unidades");
          // Mostrar modal con opciones: Formato o Tarifa
          this.$modal.show("modal-unidades-medida");
        } else if (stepNumber === 3) {
          // console.log("Soy B");
          // console.log("this.productoSeleccionado", this.productoSeleccionado);

          if (
            this.productoSeleccionado &&
            Array.isArray(this.productoSeleccionado.udMedida) &&
            !(this.productoSeleccionado.flags && this.productoSeleccionado.flags.requires_full_form) &&
            this.productoSeleccionado.udMedida.length === 1 &&
            Array.isArray(this.productoSeleccionado.idsNumier) &&
            this.productoSeleccionado.idsNumier.length > 0
          ) {
            const udActual = this.productoSeleccionado.udMedida[0];
            const udNumier = this.productoSeleccionado.idsNumier[0].codUdMedida;

            if (udActual !== udNumier) {
              console.warn(
                "[BC] Producto con unidades inconsistentes. Normalizando:",
                udNumier,
                "→",
                udActual
              );

              // Limpieza obligatoria
              this.productoSeleccionado.idsNumier = [];
              this.productoSeleccionado.tieneSubproducts = false;
            }
          }

          this.ignoreMultipleUDMedida =
            this.productoSeleccionado.udMedida.length > 1 &&
            (this.productoSeleccionado.MostrarEnListaCON ||
              this.productoSeleccionado.MostrarEnListaSUPLEMENTO) &&
            this.productoSeleccionado.tipoPendiente !== "pendienteActualizar";

          // console.log("this.productoSeleccionado.tipoPendiente", this.productoSeleccionado.tipoPendiente);
          // console.log("this.productoSeleccionado.goToStepper", this.productoSeleccionado.goToStepper);
          // console.log("this.productoSeleccionado.changeFormatToRates", this.productoSeleccionado.changeFormatToRates);
          // console.log("this.udMedidaChoiceMade", this.udMedidaChoiceMade);

          if (
            this.productoSeleccionado.tipoPendiente === "pendienteActualizar" &&
            this.productoSeleccionado.goToStepper === 1 &&
            !this.udMedidaChoiceMade &&
            this.productoSeleccionado.udMedida.length > 1 &&
            this.eraSimpleAntesFlag &&
            !yaEsMultiUnidadEnNumier
          ) {
            this.$modal.show("modal-unidades-medida");
          } else {
            this.currentStep = stepNumber;
          }
        }
        // Comprobamos si vamos a pasar al Step 4
        else if (this.currentStep === 3 && stepNumber === 4) {
          // console.log("Soy C");
          // console.log("El prod to fill form", (this.productsDataToFillForm));
          // console.log("El prod data info", (this.productDataInfo));
          // console.log("Los prods recuperados", this.productosPorTpvRecuperados);
          this.continueOnStep3();
        } else {
          this.currentStep = stepNumber;

          if (stepNumber === 2) {
            // console.log("Soy D");
            // console.log(" > Resetear datos del formulario");
            this.savedComplexFormData = null;
          }
        }

        this.$nextTick(() => {
          this.$nextTick(() => {
            this.updateProgressBar();
          });
        });
      }
    },

    // Marca o desmarca todos los TPVs en función del estado del checkbox "Seleccionar todos".
    // Si se selecciona "Seleccionar todos", se añaden todos los TPVs a la lista.
    // Si se desmarca, se vacía la lista de seleccionados
    // Finalmente, sincroniza los objetos seleccionados con la lista
    selectAllTpvServers() {
      if (this.allTpvServerSelectedBoolean) {
        this.selectedTpvServerNameList = this.tpvServerList.map(
          (tpv) => tpv.nameShow
        );
        this.selectedTpvServerList = [...this.tpvServerList];
      } else {
        this.selectedTpvServerNameList = [];
        this.selectedTpvServerList = [];
      }
      this.syncSelectedTpvServers();
    },

    // Actualiza selectedTpvServerList basándose en los nombres de TPVs seleccionados
    // Finalmente, verifica si el checkbox "Seleccionar todos" debe estar marcado o no
    syncSelectedTpvServers() {
      this.selectedTpvServerList = this.tpvServerList.filter((tpv) =>
        this.selectedTpvServerNameList.includes(tpv.nameShow)
      );
      this.updateSelectAllTpvStatus();
      //console.log("selectedTpvServerList actualizada", this.selectedTpvServerList)
      //console.log("selectedTpvServerNameList actualizada", this.selectedTpvServerNameList)
    },

    // Si el número de TPVs seleccionados es igual al total, marcar "Seleccionar todos"
    updateSelectAllTpvStatus() {
      this.allTpvServerSelectedBoolean =
        this.selectedTpvServerNameList.length === this.tpvServerList.length;
    },

    preventFocus(event) {
      event.target.blur();
    },

    // Este método obtiene la lista de categorías asociadas a una lista de negocios (listBusinesses).
    // 1.- Extrae los idBusiness de listBusinesses y los convierte en un array (idBusinessList).
    // 2.- Realiza una petición GET a la API (products/getCategoryListByBusinessList), enviando los IDs y el JWT en los parámetros.
    // 3.- Guarda la respuesta en listCategoriesByBusiness, que contiene las categorías de cada negocio.
    getCategoryListByBusinessList() {
      let vm = this;
      let idBusinessList = vm.listBusinesses.map((business) => business.id);

      var config = {
        params: {
          jwt: vm.$store.getters.jwt,
          idBusinessList: JSON.stringify(idBusinessList),
        },
        headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
      };

      return this.axios
        .get(
          this.$store.getters.apiUrl + "products/getCategoryListByBusinessList",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCategoriesByBusiness = response.data.result;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.error("Error obteniendo categorías:", error);
        });
    },

    // Este método obtiene la lista de TPV servidores asociados a una lista de negocios (listBusinesses).
    // 1.- Extrae los idBusiness de listBusinesses y los convierte en un array (idBusinessList).
    // 2.- Realiza una petición GET a la API (general/getTpvServerListByBusinessList), enviando los IDs y el JWT en los parámetros.
    // 3.- Filtra solo los negocios que tienen TPV y mapea los datos del TPV, guardando idBusiness, idTpvServer, nameShow e IVAs (iva1-iva5) en tpvServerList.
    getTpvServerListByBusinessList() {
      let vm = this;

      // Extraemos solo los IDs de listBusinesses en una lista businessIdList
      let idBusinessList = vm.listBusinesses.map((business) => business.id);

      var config = {
        params: {
          jwt: vm.$store.getters.jwt,
          idBusinessList: JSON.stringify(idBusinessList),
        },
        headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
      };

      return this.axios
        .get(
          this.$store.getters.apiUrl + "general/getTpvServerListByBusinessList",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.tpvServerList = response.data.result
              .filter((b) => b.tpvServer) // Filtrar solo los negocios con TPV
              .map((b) => {
                return {
                  idBusiness: b.idBusiness,
                  idTpvServer: b.tpvServer.id,
                  nameShow: b.tpvServer.nameShow,
                  iva1: b.tpvServer.iva1,
                  iva2: b.tpvServer.iva2,
                  iva3: b.tpvServer.iva3,
                  iva4: b.tpvServer.iva4,
                  iva5: b.tpvServer.iva5,
                };
              });

            // console.log(" > Lista de TPV Servidores:", vm.tpvServerList);
            vm.selectedTpvServerList = [];
            vm.selectedTpvServerNameList = [];
          } else {
            console.warn("No se encontraron TPVs.");
          }
        })
        .catch((error) => console.log(`Error obteniendo TPVs:`, error));
    },

    async continueOnStep3() {
      // Si todavía no terminaron las promesas
      // console.log(" > continueOnStep3");
      // console.log("this.promesasCarga", this.promesasCarga);
      if (this.promesasCarga) {
        try {
          this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
          await this.promesasCarga;
        } finally {
          if (this.loadingGeneral) {
            this.loadingGeneral.close();
            this.loadingGeneral = null;
          }
        }
      }

      this.waitingForProductsData = true;
      this.continueButtonPressedOnStep3 = true;

      // Resetea el valor para futuros clics
      setTimeout(() => (this.continueButtonPressedOnStep3 = false), 100);
    },

    finalize() {
      // console.log(" > finalizeButtonPressed.");

      // No hace ya falta esto debido a que la lógica se ha movido al backend
      // if (!this.checkCamposMateriasPrimas()) {
      //   return;
      // }

      // Es posible que el finalizeButtonPressed no sea necesario, pertenece al legacy de cuando se guardaba en el productoFormBasico
      this.finalizeButtonPressed = true; // Activa el guardado
      setTimeout(() => (this.finalizeButtonPressed = false), 100); // Resetea el valor para futuros clics

      this.saveProducts();
    },

    // Se ejecuta cuando se presiona el botón de "Volver".
    // Si el currentStep es 3, se pona True waitingForProductsData y moveBackButtonPressed, lo que indica que se está esperando la recuperación de los datos antes de retroceder.
    // Después de 100 ms, desactiva moveBackButtonPressed.
    // Si el currentStep NO es 3,
    // 1.- Vaciamos productosPorTpvRecuperados, selectedTpvServerList, selectedTpvServerNameList y productoSeleccionado
    // 2.- Llama a updateSelectAllTpvStatus() para que el checkbox de Seleccionar todos si deseleccione, en caso de estarlo.
    // 3.- Llama a moveBack() para retroceder al step1.
    moveBackPressed() {
      // console.log(" > En moveBackPressed con currentStep:", this.currentStep);

      if (this.currentStep === 3) {
        // Si estamos en el paso 3, simplemente volvemos al paso 2
        this.moveStep(2);
        return;
      }

      if (this.currentStep === 2) {
        // console.log(" > En moveBackPressed en el 2");
        // this.selectedTpvServerList = [];
        // this.selectedTpvServerNameList = [];
        this.productoSeleccionado = {
          idProdBusinessCentral: 0,
          productName: "",
          tipoIVA: "",
        };
        this.updateSelectAllTpvStatus();

        this.recetaSeleccionada = [];
        this.addMateriaPrimaButtonsPressed = [];
        this.addAllMateriaPrimaButtonPressed = false;
        this.productsDataToFillForm = [];

        // Para resetear la config de tarifas y formatos en los casos de multiples unidades de medida.
        this.crearMultiplesProductosByUdsMedida = false;
        console.log("A-TEST:1", this.crearMultiplesProductosByUdsMedida);
        this.productosMultiples = [];
        this.udMedidaChoiceMade = false;
        this.eraSimpleAntesFlag = false;
      }

      // Para cualquier otro caso, usamos el método moveBack existente
      this.moveBack();
    },

    // Se ejecuta cuando se reciben los datos de los productos al volver del step3.
    // Guarda los datos recibidos en this.productosPorTpvRecuperados.
    // Si waitingForProductsData está activo (lo que significa que el usuario estaba esperando los productos antes de retroceder), lo desactiva y llama a moveBack() para continuar con la navegación.
    moveBackToStep2(productosPorTpv) {
      // console.log(" > En moveBackToStep2 con productosPorTpv y waitingForProductsData", productosPorTpv, this.waitingForProductsData);

      // Si productosPorTpv está proporcionado, lo guardamos
      if (productosPorTpv) {
        this.productosPorTpvRecuperados = productosPorTpv;
      }

      // Si estamos esperando datos de productos, manejamos ese flujo
      if (this.waitingForProductsData) {
        this.waitingForProductsData = false;
        this.moveBack();
      } else {
        // Si no estamos esperando datos, simplemente volvemos al paso 2
        this.moveStep(2);
      }
    },

    // Maneja el paso 4 para productos con flags CON/SUPLEMENTO
    handleContinueToStep4(productData) {
      // console.log(" > En handleContinueToStep4 con productData", productData);
      if (this.isProcessingStep4) return;

      // No se usará al final
      // this.rateFlag = true;

      // ###################################################################################################
      // ############## Guardar los datos del formulario por si vuelve, que haya persistencia ##############
      // this.savedComplexFormData = productData;
      // console.log(" > En handleContinueToStep4 con savedComplexFormData", this.savedComplexFormData);
      // ###################################################################################################

      this.isProcessingStep4 = true;

      // Procedemos al paso 4
      try {
        this.continueToStep4(productData);
      } finally {
        setTimeout(() => {
          this.isProcessingStep4 = false;
        }, 1000);
      }
    },

    continueToStep4(productosPorTpv) {
      // console.log(" > En continueToStep4 con productosPorTpv", productosPorTpv);
      // Si productosPorTpv es proporcionado, lo guardamos
      if (productosPorTpv) {
        this.productosPorTpvRecuperados = productosPorTpv;
      }
      // console.log(" > En productosPorTpv", {
      //   productosPorTpv,
      //   waitingForProductsData: this.waitingForProductsData
      // });

      // console.log(" > En continueToStep4",
      //   this.productosPorTpvRecuperados
      // );

      // Si no hay receta seleccionada (productos sin subproductos/materias primas)
      if (!this.recetaSeleccionada || this.recetaSeleccionada.length === 0) {
        // console.log("Sin receta - verificar tipo de producto");

        // Si es un producto de tipo actualizar que requiere normalización
        // Detectar si es SUPLEMENTO (goToStepper === 1) O si es Formatos (crearMultiplesProductosByUdsMedida === true)

        if (
          this.productoSeleccionado.tipoPendiente === "pendienteActualizar" &&
          (this.productoSeleccionado.goToStepper === 1 ||
          this.crearMultiplesProductosByUdsMedida)
        ) {
          // console.log("editProductBC - sin receta");
          console.log("A-TEST:2", this.crearMultiplesProductosByUdsMedida);
          Swal.fire({
            type: "info",
            title: this.$t("atencion"),
            text: this.$t("productoYaCreadoMateriasPrimasIguales"),
            confirmButtonText: this.$t("continuar"),
          }).then(() => {
            this.loadingGeneral = Loading.service({
              text: this.$t("cargando"),
            });
            // console.log("O AQUI");

            // Asegurarme de que productosPorTpv sea un array
            const productos = Array.isArray(productosPorTpv)
              ? productosPorTpv
              : [productosPorTpv];

            const productosNormalizados = this.normalizeProductosNumier(
              productos,
              this.productDataInfo
            );
            // console.log(" > productosNormalizados", productosNormalizados);
            this.editProductBC(productosNormalizados);
          });
          return;
        }

        // Para otros casos sin receta, guardar directamente
        if (this.productoSeleccionado.tipoPendiente === "pendienteActualizar") {
          // console.log("editProducts - sin receta");
          this.editProducts();
        } else {
          // console.log("saveProducts - sin receta");
          this.saveProducts();
        }
        return;
      }

      // Si hay receta, seguir con el flujo de Step 4
      // Aqui tendré que ver si tengo que llamar a editProductBC o a editProducts,
      // que dependerá de si tengo el goToStepper y es un producto de tipo actualizar
      // Si se da el caso, primero habrá que normalizar el json a enviar como me pide el backend

      if (
        this.productoSeleccionado.tipoPendiente === "pendienteActualizar" &&
        (this.productoSeleccionado.goToStepper === 1 ||
        this.crearMultiplesProductosByUdsMedida)
      ) {
        console.log("A-TEST:3", this.crearMultiplesProductosByUdsMedida);
        // console.log("editProductBC - con receta");
        Swal.fire({
          type: "info",
          title: this.$t("atencion"),
          text: this.$t("productoYaCreadoMateriasPrimasIguales"),
          confirmButtonText: this.$t("continuar"),
        }).then(() => {
          this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

          // console.log(" ESTPOY SQUIO");

          // Asegurarme de que productosPorTpv sea un array
          const productos = Array.isArray(productosPorTpv)
            ? productosPorTpv
            : [productosPorTpv];

          // console.log(" > productosPorTpv", productosPorTpv);
          // console.log(" > productos", productos);
          // console.log(" > productDataInfo", this.productDataInfo);

          const productosNormalizados = this.normalizeProductosNumier(
            productos,
            this.productDataInfo
          );
          // console.log(" > productosNormalizados", productosNormalizados);
          this.editProductBC(productosNormalizados);
        });
      } else if (this.productsDataToFillForm.length > 0) {
        // console.log("editProducts");
        this.editProducts();
      } else {
        // console.log(" > En continueToStep4 con productosPorTpv y waitingForProductsData", productosPorTpv, this.waitingForProductsData);

        if (this.waitingForProductsData) {
          this.waitingForProductsData = false;
          this.currentStep = 4;

          this.$nextTick(() => {
            this.$nextTick(() => {
              this.updateProgressBar();
            });
          });
        }
      }
    },

    moveBack() {
      // console.log(" > En moveBack con currentStep y waitingForProductsData ", this.currentStep, this.waitingForProductsData);

      if (this.currentStep === 3 && this.waitingForProductsData) {
        // Esperamos a que moveBackToStep2 complete la navegación
        return;
      }
      // console.log(" > He pasado el return");
      this.moveStep(this.currentStep - 1);
    },

    // Métodos para tabs, búsqueda y paginación
    setActiveTab(tab) {
      this.activeTab = tab;
      this.currentPage = 1; // Resetar la paginación cuando cambia entre tabs
    },

    onSearchInput() {
      this.isSearch = this.searchQuery.length > 0;
      this.currentPage = 1; // Resetar la paginación cuando se realiza una búsqueda
    },

    clearSearch() {
      this.searchQuery = "";
      this.isSearch = false;
      this.currentPage = 1; // Resetar la paginación cuando se limpia la búsqueda
    },

    filterBySearch(materias) {
      if (!this.searchQuery) return materias;
      const query = this.searchQuery.toLowerCase();
      return materias.filter((materia) =>
        materia.productName.toLowerCase().includes(query)
      );
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPags) {
        this.currentPage = page;
      }
    },

    // En caso de intentar recargar la página avisa al usuario de que perderá el progreso
    preventReload(event) {
      event.preventDefault();
      event.returnValue = this.$t("swalSalirFromProductosBusinessCentralText");
    },

    // Manejador de respuesta exitosa
    handleSaveResponse(response) {
      // Cerrar loader si está activo
      if (this.loadingGeneral) this.loadingGeneral.close();

      const resp = response && response.data ? response.data : {};
      const respData = resp.data || {};
      const savedProductIds = respData.savedProductIds || resp.savedProductIds || null;
      const successFlag = resp.response === true || respData.response === true;

      // Construir lista de IDs extraídos desde la respuesta (si existe)
      let idsGuardados = [];
      if (savedProductIds) {
        if (typeof savedProductIds === 'object' && !Array.isArray(savedProductIds)) {
          idsGuardados = Object.values(savedProductIds).flat().map(id => String(id).trim());
        } else if (Array.isArray(savedProductIds)) {
          idsGuardados = savedProductIds.map(id => String(id).trim());
        } else if (typeof savedProductIds === 'string') {
          idsGuardados = [String(savedProductIds).trim()];
        }
      }

      // PLU1s de los productos que se estaban guardando (guardados en saveProducts)
      const productosGuardandose = Array.isArray(this.productosGuardandose) ? this.productosGuardandose.map(id => String(id).trim()) : [];

      // Unir ambas fuentes de IDs (respuesta del backend y los que se enviaron)
      const idsToRemove = Array.from(new Set([...idsGuardados, ...productosGuardandose]));

      // Si hubo éxito o hay ids para eliminar, filtramos la lista local
      if (successFlag || idsToRemove.length > 0) {
        const cantidadAntes = this.productosPendientes.length;

        this.productosPendientes = this.productosPendientes.filter(producto => {
          const plu1 = String(producto.PLU1 || "").trim();
          const idProdBC = String(producto.idProdBusinessCentral || "").trim();

          const debeEliminar = idsToRemove.length > 0
            ? (idsToRemove.includes(plu1) || idsToRemove.includes(idProdBC))
            : productosGuardandose.includes(plu1) || productosGuardandose.includes(idProdBC);

          if (debeEliminar) {
            // console.log(`🗑️ Eliminando: ${producto.productName} (PLU1:${plu1} idProdBC:${idProdBC})`);
          }

          return !debeEliminar;
        });

        // Limpiar la lista temporal
        this.productosGuardandose = [];
        // Asegurar que la vista muestre el cambio: resetear paginación y forzar actualización
        try {
          this.currentPage = 1;
          this.$nextTick(() => {
            if (typeof this.updateProgressBar === 'function') this.updateProgressBar();
            if (typeof this.$forceUpdate === 'function') this.$forceUpdate();
          });
        } catch (e) {
          console.warn('No se pudo forzar actualización de la UI:', e);
        }

        const cantidadDespues = this.productosPendientes.length;
        // console.log(`✅ Productos eliminados: ${cantidadAntes - cantidadDespues}, Restantes: ${cantidadDespues}`);

        Swal.fire({
          title: this.$t("swalProductoSincronizadoTitle"),
          text:
            this.productosPendientes.length > 0
              ? this.$t("swalProductoSincronizadoTextNPendientes")
              : this.$t("swalProductoSincronizadoText0Pendientes"),
          type: "success",
          showCancelButton: this.productosPendientes.length > 0,
          cancelButtonText: this.$t("swalProductoSincronizadoButtonSeguir"),
          confirmButtonText: this.$t(
            "swalProductoSincronizadoButtonTerminar"
          ),
          buttonsStyling: true,
          cancelButtonClass: "btn btn-primary btn-fill",
          cancelButtonColor: "#1a73e8",
          confirmButtonClass:
            "btn btn-outline-primary btn-fill swal2-cancel-btn",
          confirmButtonColor: "#aaaaaa",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((result) => {
          if (result.value) {
            this.shouldRedirect = true;
            this.$router.push({
              name: "integraciones",
              params: { redirected: false },
            });
          } else {
            this.resetBusinessCentral();
          }
        });

        return Promise.resolve();
      }

      console.warn("Error, no se guardaron los productos.");
      console.warn("Response data:", response.data);
      return Promise.reject(new Error("No se guardaron los productos"));
    },

    // Manejador de errores
    handleSaveError(error) {
      console.error("Error al guardar productos:", error.message);
      this.loadingGeneral.close();

      Swal.fire({
        title: this.$t("error"),
        text: this.$t("serverError"),
        type: "error",
        confirmButtonText: this.$t("vale"),
      });

      return Promise.reject(error);
    },

    resetBusinessCentral() {
      // 🎯 NOTA: El array productosPendientes ya está filtrado por handleSaveResponse()
      // cuando el usuario elige "Seguir sincronizando", así que los productos sincronizados
      // YA han sido eliminados y no aparecerán en el Step 1. No es necesario recargarlos desde BC.

      this.moveStep(1);
      this.productoSeleccionado = {
        idProdBusinessCentral: 0,
        productName: "",
        tipoIVA: "",
      };
      this.selectedTpvServerList = [];
      this.selectedTpvServerNameList = [];
      this.allTpvServerSelectedBoolean = false;

      this.finalizeButtonPressed = false; //  Es posible que el finalizeButtonPressed no sea necesario, pertenece al legacy de cuando se guardaba en el productoFormBasico

      this.continueButtonPressedOnStep3 = false;
      this.productosPorTpvRecuperados = [];
      this.productsDataToFillForm = [];

      // Reiniciar variables relacionadas con múltiples productos
      this.crearMultiplesProductosByUdsMedida = false;
      console.log("A-TEST:4", this.crearMultiplesProductosByUdsMedida);
      this.productosMultiples = [];
      this.udMedidaChoiceMade = false;

      this.recetaSeleccionada = [];
      this.addMateriaPrimaButtonsPressed = [];
      this.addAllMateriaPrimaButtonPressed = false;
    },

    // =========================================================
    // HELPER: Construye productosMultiples a partir de los datos ya
    // recuperados en productosPorTpvRecuperados. Se llama tanto desde
    // crearMultiplesProductosByUdMedida (elección modal) como desde
    // getProductDataInfo cuando el producto YA es Formato en Numier.
    // =========================================================
    _buildProductosMultiplesDesdeFormato() {
      // =========================================================
      // MAPA DE PRODUCTOS EXISTENTES POR UNIDAD (PLU3)
      // =========================================================
      let mapaProductosPorUnidad = {};

      if (this.productosPorTpvRecuperados) {
        // productDataInfo.tpvs is an object or array of objects, we need to carefully get the array of productos
        const rec = Array.isArray(this.productosPorTpvRecuperados) ? this.productosPorTpvRecuperados : Object.values(this.productosPorTpvRecuperados);

        rec.forEach((tpvWrapper) => {
          // Find the actual productos array inside tpv
          let productosList = [];

          // It might be directly an array of items
          if (Array.isArray(tpvWrapper)) {
            productosList = tpvWrapper;
          }
          // Or it might be inside tpvWrapper.productos
          else if (tpvWrapper && tpvWrapper.productos && Array.isArray(tpvWrapper.productos)) {
            productosList = tpvWrapper.productos;
          }

          productosList.forEach((pw) => {
            const prod = pw.producto || pw;
            if (prod && prod.PLU3) {
              mapaProductosPorUnidad[prod.PLU3.trim().toUpperCase()] = prod;
            }
          });
        });
      }

      // console.log("[BC] mapaProductosPorUnidad construido:", mapaProductosPorUnidad);

      // Helpers
      const toBool = (val) => {
        if (typeof val === "boolean") return val;
        if (val === 1 || val === "1" || val === true || val === "true") return true;
        return false;
      };

      const toNumber = (val) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
      };

      // =========================================================
      // 🔴 DETECTAR UNIDAD ANTIGUA Y SU PRECIO
      // =========================================================
      let udAntigua = null;
      let precioAntiguo = 0;

      if (
        Array.isArray(this.productoSeleccionado.idsNumier) &&
        this.productoSeleccionado.idsNumier.length === 1
      ) {
        const antiguo = this.productoSeleccionado.idsNumier[0];
        udAntigua = antiguo.codUdMedida.trim().toUpperCase();

        if (antiguo.price1 !== undefined && antiguo.price1 !== null) {
          precioAntiguo = toNumber(antiguo.price1);
        } else if (antiguo.precio !== undefined && antiguo.precio !== null) {
          precioAntiguo = toNumber(antiguo.precio);
        } else if (antiguo.price !== undefined && antiguo.price !== null) {
          precioAntiguo = toNumber(antiguo.price);
        } else {
          precioAntiguo = 0;
        }
      }

      // =========================================================
      // CASOS DE CREACIÓN DE PRODUCTOS MÚLTIPLES
      // =========================================================
      if (
        this.productoSeleccionado.tipoPendiente === "pendienteActualizar" &&
        this.productoSeleccionado.goToStepper === 1 &&
        this.productoSeleccionado.changeFormatToRates === 0
      ) {
        this.indexProductoActivo = 0;

        this.productosMultiples = this.productoSeleccionado.udMedida.map((ud, i) => {
          const udKey = ud.trim().toUpperCase();
          const productoExistente = mapaProductosPorUnidad[udKey];
          const isExistente = !!productoExistente;

          // console.log(`[BC] UD: ${ud} (${udKey}) → existente: ${isExistente}`, productoExistente);

          return {
            unidad: ud,
            producto: {
              nombreProducto: this.productoSeleccionado.udMedida.length > 1 ? `${this.productoSeleccionado.productName} ${ud}` : this.productoSeleccionado.productName,
              descripcion: isExistente ? productoExistente.description || "" : "",
              codigoBarras: isExistente ? productoExistente.barCode || "" : "",
              color: isExistente ? productoExistente.color || "amarillo" : "amarillo",

              price1: isExistente
                ? toNumber(productoExistente.price1)
                : udKey === udAntigua
                  ? precioAntiguo
                  : 0,

              price2: isExistente ? toNumber(productoExistente.price2) : 0,
              price3: isExistente ? toNumber(productoExistente.price3) : 0,
              price4: isExistente ? toNumber(productoExistente.price4) : 0,

              selPrice1: isExistente ? toBool(productoExistente.selPrice1) : false,
              selPrice2: isExistente ? toBool(productoExistente.selPrice2) : false,
              selPrice3: isExistente ? toBool(productoExistente.selPrice3) : false,
              selPrice4: isExistente ? toBool(productoExistente.selPrice4) : false,

              namePrice1: isExistente ? productoExistente.namePrice1 || "" : "",
              namePrice2: isExistente ? productoExistente.namePrice2 || "" : "",
              namePrice3: isExistente ? productoExistente.namePrice3 || "" : "",
              namePrice4: isExistente ? productoExistente.namePrice4 || "" : "",

              idCategoria: isExistente ? toNumber(productoExistente.idCategory) : 0,
              idTpvServer: null,
              multiProductoIndex: i,
            },
          };
        });

      } else if (
        this.productoSeleccionado.tipoPendiente === "pendienteActualizar" &&
        this.productoSeleccionado.goToStepper === 1 &&
        this.productoSeleccionado.changeFormatToRates === 1
      ) {
        this.indexProductoActivo = 0;
        const unidadesDeMedida = this.productoSeleccionado.udMedida || [];

        this.productosMultiples = unidadesDeMedida.map((ud, i) => {
          const udKey = ud.trim().toUpperCase();
          const productoExistente = mapaProductosPorUnidad[udKey];
          const isExistente = !!productoExistente;

          return {
            unidad: ud,
            producto: {
              nombreProducto: unidadesDeMedida.length > 1 ? `${this.productoSeleccionado.productName} ${ud}` : this.productoSeleccionado.productName,
              descripcion: isExistente ? productoExistente.descripcion || "" : "",
              codigoBarras: isExistente ? productoExistente.codigoBarras || "" : "",
              color: isExistente ? productoExistente.color || "amarillo" : "amarillo",

              price1: isExistente
                ? toNumber(productoExistente.price1)
                : udKey === udAntigua
                  ? precioAntiguo
                  : 0,

              price2: 0,
              price3: 0,
              price4: 0,

              selPrice1: false,
              selPrice2: false,
              selPrice3: false,
              selPrice4: false,

              namePrice1: ud,
              namePrice2: "",
              namePrice3: "",
              namePrice4: "",

              multiProductoIndex: i,
              esUnidadNueva: !isExistente,
              idCategoria: isExistente ? toNumber(productoExistente.idCategory) : 0,
            },
          };
        });

      } else {
        this.indexProductoActivo = 0;

        this.productosMultiples = this.productoSeleccionado.udMedida.map((ud, i) => {
          const udKey = ud.trim().toUpperCase();
          const productoExistente = mapaProductosPorUnidad[udKey];
          const isExistente = !!productoExistente;

          return {
            unidad: ud,
            producto: {
              nombreProducto: this.productoSeleccionado.udMedida.length > 1 ? `${this.productoSeleccionado.productName} ${ud}` : this.productoSeleccionado.productName,
              descripcion: "",
              codigoBarras: "",
              color: "amarillo",

              price1: isExistente
                ? toNumber(productoExistente.price1)
                : udKey === udAntigua
                  ? precioAntiguo
                  : 0,

              price2: isExistente ? toNumber(productoExistente.price2) : 0,
              price3: isExistente ? toNumber(productoExistente.price3) : 0,
              price4: isExistente ? toNumber(productoExistente.price4) : 0,

              selPrice1: isExistente ? toBool(productoExistente.selPrice1) : false,
              selPrice2: isExistente ? toBool(productoExistente.selPrice2) : false,
              selPrice3: isExistente ? toBool(productoExistente.selPrice3) : false,
              selPrice4: isExistente ? toBool(productoExistente.selPrice4) : false,

              namePrice1: isExistente ? productoExistente.namePrice1 || "" : "",
              namePrice2: isExistente ? productoExistente.namePrice2 || "" : "",
              namePrice3: isExistente ? productoExistente.namePrice3 || "" : "",
              namePrice4: isExistente ? productoExistente.namePrice4 || "" : "",

              idCategoria: isExistente ? toNumber(productoExistente.idCategory) : 0,
              idTpvServer: null,
              multiProductoIndex: i,
            },
          };
        });
      }
    },

    crearMultiplesProductosByUdMedida() {
      this.$modal.hide("modal-unidades-medida");
      this.crearMultiplesProductosByUdsMedida = true;
      console.log("A-TEST:5", this.crearMultiplesProductosByUdsMedida);
      this.udMedidaChoiceMade = true;

      // Delegar la construcción de productosMultiples al helper compartido
      this._buildProductosMultiplesDesdeFormato();

      // =========================================================
      // FINAL
      // =========================================================
      this.$nextTick(() => {
        this.moveStep(3);
      });
    },


    crearUnProductoByUdMedida() {
      // console.log(" > Crear solo un producto con tarifas para:", this.productoSeleccionado.productName);
      this.$modal.hide("modal-unidades-medida");
      this.crearMultiplesProductosByUdsMedida = false;
      console.log("A-TEST:6", this.crearMultiplesProductosByUdsMedida);
      this.udMedidaChoiceMade = true;

      // Asegurar que productosMultiples esté vacío
      this.productosMultiples = [];
      // console.log( " > Creando un producto con tarifas para:", this.productoSeleccionado.productName );
      // console.log(" > Lista de TPV Server:", this.tpvServerList);
      // console.log(" > ProductDataInfo:", this.productDataInfo);
      this.moveStep(3);
    },

    ocultarModalActualizarProducto() {
      this.$modal.hide("modal-confirmar-datos_form");
    },

    getProductosElaboradosSemielaboradosFromBusinessCentral() {
      // console.log(" > Llamando a Business Central para obtener recetas...");

      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
      };

      return this.axios
        .post(
          this.$store.getters.apiUrl +
          "products/getProductosElaboradosSemielaboradosFromBusinessCentral",
          params,
          config
        )
        .then((response) => {
          if (response.data.response) {
            // console.log(" > Recetas obtenidas:", response.data.recetas);

            this.recetasFromBusinessCentral = response.data.recetas.map(
              (receta) => ({
                idRecetaBusinessCentral: receta.codProdReceta,
                nombreReceta: receta.nombreReceta,
                linea: receta.linea,
                idMateriaPrimaBusinessCentral: receta.codProductoInsumo,
                nombreMateriaPrima: receta.nombreProdInsumo,
                udMedidaMateriaPrima: receta.unidadMedidaProdInsumo,
                cantidadMateriaPrima: receta.cantidadProdInsumo,
                auxiliaryIndex1: receta.auxiliaryIndex1,
                lmEnsambladoFilterOnly: receta.lmEnsambladoFilterOnly,
                idNumier: receta.idNumier || null,
                mostrarEnListaCON: receta.mostrarEnListaCON,
                mostrarEnListaSUPLEMENTO: receta.mostrarEnListaSUPLEMENTO,
              })
            );
          } else {
            console.warn("Error al obtener recetas:", response.data.message);
            // if (this.loadingGeneral) this.loadingGeneral.close();
          }
        })
        .catch((error) => {
          console.error("Error:", error.message);
          if (this.loadingGeneral) this.loadingGeneral.close();
          Swal.fire({
            title: this.$t("error"),
            text: this.$t("errorRecetasBC"),
            type: "error",
            confirmButtonText: this.$t("vale"),
          });
        });
    },

    saveAdvancedProductTransparent(options = {}) {
      const { silent = false } = options;

      this.updateProductTypeFlags();

      let config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
        idBusinessCentral: this.productoSeleccionado.idProdBusinessCentral,
        flags: this.productTypeFlags,
      };

      return this.axios
        .post(
          this.$store.getters.apiUrl + "businesscentral/editProductAdvanced/auto",
          params,
          config
        )
        .then((response) => {
          const success =
            (response.data && response.data.editedIds && response.data.editedIds.length > 0) ||
            (response.data && response.data.response);

          if (success) {
            if (!silent && this.loadingGeneral) this.loadingGeneral.close();

            if (this.productoSeleccionado && this.productoSeleccionado.idProdBusinessCentral) {
              const updatedProductId = this.productoSeleccionado.idProdBusinessCentral;
              this.productosPendientes = this.productosPendientes.filter(
                (p) => p.idProdBusinessCentral !== updatedProductId
              );
              this.currentPage = 1;
            }

            if (silent) return { success: true };

            Swal.fire({
              title: this.$t("swalProductoSincronizadoTitle"),
              text:
                this.productosPendientes.length > 0
                  ? this.$t("swalProductoSincronizadoTextNPendientes")
                  : this.$t("swalProductoSincronizadoText0Pendientes"),
              type: "success",
              showCancelButton: this.productosPendientes.length > 0,
              cancelButtonText: this.$t("swalProductoSincronizadoButtonTerminar"),
              confirmButtonText: this.$t("swalProductoSincronizadoButtonSeguir"),
              buttonsStyling: true,
              cancelButtonClass: "btn btn-primary btn-fill",
              cancelButtonColor: "#1a73e8",
              confirmButtonClass: "btn btn-outline-primary btn-fill swal2-cancel-btn",
              confirmButtonColor: "#aaaaaa",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then((result) => {
              if (result.value) this.shouldRedirect = true;
            });

            return { success: true };
          } else {
            if (!silent) {
              console.warn("No se pudieron editar productos.");
              if (this.loadingGeneral) this.loadingGeneral.close();
              Swal.fire({
                title: this.$t("error"),
                text: this.$t("serverError"),
                type: "error",
                confirmButtonText: this.$t("vale"),
              });
            }
            return { success: false, message: response.data && response.data.message };
          }
        })
        .catch((error) => {
          if (!silent) {
            console.error("Error al editar productos:", error.message);
            if (this.loadingGeneral) this.loadingGeneral.close();
            Swal.fire({
              title: this.$t("error"),
              text: this.$t("serverError"),
              type: "error",
              confirmButtonText: this.$t("vale"),
            });
          }
          return { success: false, message: error.message };
        });
    },

    async getSubproductsByBusinessList() {
      let config = {
        params: {
          jwt: this.$store.getters.jwt,
          listBusinesses: JSON.stringify(this.tpvServerList),
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        jwt: this.$store.getters.jwt,
      };

      await this.axios
        .post(
          this.$store.getters.apiUrl +
          "subproducts/getSubproductsByBusinessList",
          params,
          config
        )
        .then((response) => {
          if (response.data.response) {
            this.subproductsByBusinessList = response.data.result;
            // console.log(" > Subproductos por negocio:", this.subproductsByBusinessList);

            if (this.subproductsByBusinessList.length > 0) {
              this.processRelacionSubproductos();
            }
          } else {
            console.warn(
              "No se pudieron obtener los subproductos:",
              response.data.message
            );
          }
        })
        .catch((error) => {
          console.error("Error al obtener subproductos:", error.message);
        });
    },

    // Añade a productoSeleccionado una a una las materias primas en el step 4. No son los subproducts de Numier, aún tienen el id y nombre de Business Central
    addMateriaPrima(materia) {
      const id = materia.idMateriaPrimaBusinessCentral;

      // Si ya ha sido añadida, no hacer nada
      if (this.addMateriaPrimaButtonsPressed.includes(id)) return;

      // Inicializar array si no existe
      if (!this.productoSeleccionado.materiasPrimas) {
        this.$set(this.productoSeleccionado, "materiasPrimas", []);
      }

      this.productoSeleccionado.materiasPrimas.push({
        idMateriaPrimaBusinessCentral: id,
        nombreMateriaPrima: materia.nombreMateriaPrima,
      });

      this.addMateriaPrimaButtonsPressed.push(id);

      // Si ya están todas añadidas
      if (
        this.addMateriaPrimaButtonsPressed.length ===
        this.recetaSeleccionada.length
      ) {
        this.addAllMateriaPrimaButtonPressed = true;
      }
    },

    // Añade a productoSeleccionado todas las materias primas en el step 4.
    // No son los subproducts de Numier, aún tienen el id y nombre de Business Central
    addAllMateriasPrimas() {
      if (!this.productoSeleccionado.materiasPrimas) {
        this.$set(this.productoSeleccionado, "materiasPrimas", []);
      }

      // Log all material IDs that will be added
      const materialIds = this.recetaSeleccionada.map((m) => ({
        id: m.idMateriaPrimaBusinessCentral,
        name: m.nombreMateriaPrima,
      }));
      // console.log('Añadiendo todas las materias primas con IDs:', materialIds);

      this.recetaSeleccionada.forEach((materia) => {
        const id = materia.idMateriaPrimaBusinessCentral;

        if (!this.addMateriaPrimaButtonsPressed.includes(id)) {
          this.productoSeleccionado.materiasPrimas.push({
            idMateriaPrimaBusinessCentral: id,
            nombreMateriaPrima: materia.nombreMateriaPrima,
          });

          this.addMateriaPrimaButtonsPressed.push(id);
        }
      });

      this.addAllMateriaPrimaButtonPressed = true;
    },

    processRelacionSubproductos() {
      const resultadoFinal = [];

      for (const relacion of this.subproductsNumierByBusinessCentral) {
        const idMateriaPrimaBusinessCentral =
          relacion.idSubproductBusinessCentral;
        const idsNumier = relacion.idsSubproductsNumier || [];

        const subproductosRelacionados = [];

        // La API devuelve `subproductsNumier: [{ idNumier, idTpv }]`: el TPV de cada subproducto
        // viene resuelto desde base de datos y no hay que deducirlo recorriendo las listas.
        const conTpv = Array.isArray(relacion.subproductsNumier)
          ? relacion.subproductsNumier.filter(
            (s) => s && s.idNumier !== undefined && s.idTpv !== undefined && s.idTpv !== null
          )
          : [];

        if (conTpv.length > 0) {
          for (const sub of conTpv) {
            subproductosRelacionados.push({
              idSubproductNumier: parseInt(sub.idNumier),
              idTpvServer: sub.idTpv,
            });
          }
        } else {
          // FALLBACK (API antigua sin idTpv): buscar el id en la lista de subproductos de cada TPV
          for (const idNumier of idsNumier) {
            for (const negocio of this.subproductsByBusinessList) {
              const idTpv = negocio.idTpvServer;

              const match = negocio.subproducts.find(
                (sub) => parseInt(sub.id) === idNumier
              );

              if (match) {
                subproductosRelacionados.push({
                  idSubproductNumier: idNumier,
                  idTpvServer: idTpv,
                });
              }
            }
          }
        }

        if (subproductosRelacionados.length > 0) {
          resultadoFinal.push({
            idSubproductBusinessCentral: idMateriaPrimaBusinessCentral,
            subproductosNumier: subproductosRelacionados,
          });
        }
      }

      // console.log(" > Resultado final del cruce:", resultadoFinal);
      this.relacionSubproductsFinal = resultadoFinal;
      if (this.loadingGeneral) this.loadingGeneral.close();
    },

    actualizarProductosPorTpvConMateriasPrimas() {
      if (
        !this.recetaSeleccionada ||
        this.recetaSeleccionada.length === 0 ||
        !Array.isArray(this.relacionSubproductsFinal)
      ) {
        console.warn("No se puede actualizar productos: Datos Incompletos");
        return;
      }

      // console.log(" > Iniciando actualización de productosPorTpvRecuperados...");
      // console.log(" > recetaSeleccionada:", this.recetaSeleccionada);
      // console.log(" > relacionSubproductsFinal:", this.relacionSubproductsFinal);

      // Recorremos cada producto por TPV
      this.productosPorTpvRecuperados.forEach((productoPorTpv) => {
        const idTpvActual = productoPorTpv.idTpvServer;
        // console.log(` > Procesando producto del TPV ${idTpvActual}`);

        // Reiniciamos el array de materias primas
        this.$set(productoPorTpv, "materiasPrimas", []);

        // Recorremos todas las materias primas de la receta seleccionada
        for (const materiaPrimaFromRecetaSeleccionada of this
          .recetaSeleccionada) {
          const idMateriaPrimaBC = parseInt(
            materiaPrimaFromRecetaSeleccionada.idMateriaPrimaBusinessCentral
          );

          // console.log(` > Buscando relación para materia prima BC: ${idMateriaPrimaBC}`);

          // Buscar relación en relacionSubproductsFinal
          const relacionEncontrada = this.relacionSubproductsFinal.find(
            (relacion) =>
              parseInt(relacion.idSubproductBusinessCentral) ===
              idMateriaPrimaBC
          );

          if (!relacionEncontrada) {
            console.warn(
              `No se encontró relación para materia prima BC ${idMateriaPrimaBC}`
            );
            continue;
          }

          // console.log(" > Relación encontrada:", relacionEncontrada);

          // Recorremos los subproductos Numier dentro de esa relación
          if (Array.isArray(relacionEncontrada.subproductosNumier)) {
            for (const subproductoNumier of relacionEncontrada.subproductosNumier) {
              const mismoTpv = subproductoNumier.idTpvServer == idTpvActual;
              if (mismoTpv) {
                const yaExiste = productoPorTpv.materiasPrimas.some(
                  (mp) => mp.id === subproductoNumier.idSubproductNumier
                );

                if (!yaExiste) {
                  productoPorTpv.materiasPrimas.push({
                    id: subproductoNumier.idSubproductNumier,
                    tipo:
                      materiaPrimaFromRecetaSeleccionada.tipoMateriaPrima || "",
                    variacionPrecio: parseFloat(
                      materiaPrimaFromRecetaSeleccionada.variacionPrecio || 0
                    ).toFixed(2),
                    //aqui añadimos la cantidad
                    cantidadBC: parseFloat(
                      materiaPrimaFromRecetaSeleccionada.cantidadMateriaPrima ||
                      0
                    ).toFixed(21),
                  });

                  // console.log(` > Añadido subproducto ${subproductoNumier.idSubproductNumier} a producto del TPV ${idTpvActual}`);
                } else {
                  // console.log( `Ya existía subproducto ${subproductoNumier.idSubproductNumier} en este producto` );
                }

                break; // Ya procesamos la relación con ese TPV
              }
            }
          } else {
            console.warn(
              "subproductosNumier no es un array válido en la relación"
            );
          }
        }
      });

      // console.log(" > Resultado final de productosPorTpvRecuperados con materiasPrimas:");
      // console.log(JSON.parse(JSON.stringify(this.productosPorTpvRecuperados)));
    },

    evitarComasDecimales(e) {
      if (e.key === ",") e.preventDefault();
    },

    selectAll(e) {
      e.target.select();
    },

    getModeloBaseReceta() {
      return {
        idRecetaBusinessCentral: "",
        nombreReceta: "",
        linea: 0,
        idMateriaPrimaBusinessCentral: "",
        nombreMateriaPrima: "",
        udMedidaMateriaPrima: "",
        cantidadMateriaPrima: 0,
        auxiliaryIndex1: "",
        lmEnsambladoFilterOnly: null,
        tipoMateriaPrima: "",
        variacionPrecio: 0,
        editado: false,
      };
    },

    checkCamposMateriasPrimas() {
      const errores = new Set();

      // Verificar que cada materia prima tenga un tipo seleccionado
      const faltaTipoEnAlguna = this.recetaSeleccionada.some(
        (linea) =>
          !linea.tipoMateriaPrima || linea.tipoMateriaPrima.trim() === ""
      );
      if (faltaTipoEnAlguna) {
        errores.add(this.$t("erroresAddTipoMateriaPrima"));
      }

      // Verificar que se hayan añadido todas las materias primas
      if (!this.addAllMateriaPrimaButtonPressed) {
        errores.add(this.$t("erroresAddTodasMateriasPrimas"));
      }

      if (errores.size > 0) {
        Swal.fire({
          title: this.$t("atencion"),
          html: `<div>${this.$t(
            "swalCamposObligatoriosFromProductosBusinessCentralText"
          )}</div><div style="text-align: left;"><br><ul><li>${[
            ...errores,
          ].join("</li><li>")}</li></ul></div>`,
          confirmButtonClass: "btn btn-info btn-fill",
          type: "info",
        });
        return false;
      }

      return true;
    },

    // El método getDataFromProducts se encarga de recuperar los datos de los productos sincronizados para rellenar el formulario cuando un producto está marcado como pendienteActualizar
    // async getDataFromProducts(notStopLoading = true) {
    //   if (!this.productoSeleccionado.idProdBusinessCentral) {
    //     console.warn("No hay producto seleccionado con ID válido.");
    //     return;
    //   }

    //   this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

    //   const config = {
    //     params: {
    //       jwt: this.$store.getters.jwt,
    //       idProdBusinessCentral: JSON.stringify(this.productoSeleccionado.idProdBusinessCentral)
    //     },
    //     headers: { Authorization: "Bearer " + this.$store.getters.jwt },
    //   };

    //   var params = {
    //     jwt: this.$store.getters.jwt,
    //   };

    //   this.axios
    //     .post(this.$store.getters.apiUrl + "products/getDataFromProducts", params, config)
    //     .then(response => {
    //       if (response.data.response) {
    //         // console.log(" > Datos del producto desde Numier por idProdBusinessCentral:", response.data.result);
    //         this.productsDataToFillForm = response.data.result;

    //         this.productosPorTpvRecuperados = this.productsDataToFillForm;

    //         console.log("los datos para el formulario son:", this.productsDataToFillForm);
    //         console.log("los datos rescupados por tpv son:", this.productosPorTpvRecuperados);

    //         // Para el caso 3:
    //         // Detectamos si es tipo "Formatos" por PLU2 y vamos a recuperar, de los datos obtenidos los campos comunes de cada formato
    //         if (this.productoSeleccionado.tipoPendiente === "pendienteActualizar" && this.productsDataToFillForm.length > 1) {

    //           let case3 = false;
    //           if (this.productsDataToFillForm.length > 0 && this.productsDataToFillForm[0].PLU2 === "Formatos") {
    //             case3 = true;
    //           }

    //           if (case3) {
    //             // console.log(" > Actualizar producto Caso 3");
    //             this.crearMultiplesProductosByUdsMedida = true;
    //             this.udMedidaChoiceMade = true;

    //             const agrupadoPorFormato = {};
    //             const toBool = val => val === "1";
    //             const toInt = val => parseInt(val) || 0;

    //             this.productsDataToFillForm.forEach((prod) => {
    //               const formato = prod.PLU3 || "DEFAULT";
    //               if (!agrupadoPorFormato[formato]) {
    //                 agrupadoPorFormato[formato] = {
    //                   unidad: prod.unidadMedida || prod.udMedida || "",
    //                   producto: {
    //                     nombreProducto: prod.name || "",
    //                     descripcion: prod.description || "",
    //                     codigoBarras: prod.barCode || "",
    //                     color: prod.color || "",
    //                     namePrice1: prod.namePrice1,
    //                     namePrice2: prod.namePrice2,
    //                     namePrice3: prod.namePrice3,
    //                     namePrice4: prod.namePrice4,
    //                     orden: prod.orderCode,
    //                     baja: !toBool(prod.active),
    //                     selPrice1: toBool(prod.selPrice1),
    //                     selPrice2: toBool(prod.selPrice2),
    //                     selPrice3: toBool(prod.selPrice3),
    //                     selPrice4: toBool(prod.selPrice4),
    //                     grupo_enlazado: toInt(prod.grupo_enlazado), multiProductoIndex: Object.keys(agrupadoPorFormato).length,
    //                     preciosPorTpv: []
    //                   }
    //                 };
    //               }

    //               prod.multiProductoIndex = agrupadoPorFormato[formato].producto.multiProductoIndex;
    //             });

    //             this.productosMultiples = Object.values(agrupadoPorFormato);
    //           }
    //         }

    //         this.fillSelectedTpvServerListByProductsData();

    //       }
    //       // else {
    //       //   console.warn("No se obtuvieron datos:", response.data.message);
    //       //   this.loadingGeneral.close();
    //       // }
    //     })
    //     .catch(error => {
    //       console.error("Error en getDataFromProducts:", error.message);
    //       this.loadingGeneral.close();
    //     });
    // },

    async getProductDataInfo(idProdBusinessCentral, changeFormatToRates) {
      // console.log("Se ha llamado a getProductDataInfo");

      const config = {
        params: {
          jwt: this.$store.getters.jwt,
          listBusinesses: this.listBusinesses.map((b) => b.id).join(","),
          idProdBusinessCentral: idProdBusinessCentral,
        },
        headers: {
          Authorization: "Bearer " + this.$store.getters.jwt,
        },
      };

      try {
        const response = await this.axios.get(
          this.$store.getters.apiUrl + "products/getProductDataInfo",
          config
        );

        const productData = response.data.productDataInfo;
        this.productDataInfo = JSON.parse(JSON.stringify(productData));

        if (response.data.response && productData && productData.tpvs) {
          // console.log(" > Datos del producto a actualizar:", productData);
          this.loadingGeneral.close();

          // flag de changeFormatToRates
          if (changeFormatToRates !== undefined) {
            this.productoSeleccionado.changeFormatToRates = changeFormatToRates;
            // console.log("changeFormatToRates", changeFormatToRates);
          }

          // Extraer los idTpv de la respuesta
          const tpvIds = Object.keys(productData.tpvs);

          // Encontrar los TPVs correspondientes en tpvServerList
          const selectedTpvs = this.tpvServerList.filter((tpv) =>
            tpvIds.includes(tpv.idTpvServer.toString())
          );

          // Actualizar las listas de TPVs seleccionados
          this.selectedTpvServerList = [...selectedTpvs];
          this.selectedTpvServerNameList = selectedTpvs.map(
            (tpv) => tpv.nameShow
          );

          // Sincronizar la UI
          this.syncSelectedTpvServers();

          // Guardar los datos del producto
          this.$set(this, "productosPorTpvRecuperados", productData.tpvs);
          console.log("productData.tpvs", productData.tpvs);

          // Detectar si el producto existente en Numier es Formato o Tarifa y configurar el flag
          var esFormatoExistente = false;
          var esTarifaExistente = false;

          console.log("esFormatoExistente", esFormatoExistente);

          var tpvsKeysData = Object.keys(productData.tpvs);
          for (var ti = 0; ti < tpvsKeysData.length; ti++) {
            console.log("[A1-tpvsKeysData]");
            var tpvData = productData.tpvs[tpvsKeysData[ti]];
            if (tpvData.productos && Array.isArray(tpvData.productos)) {
              console.log("[B2-tpvsKeysData]");
              for (var pi = 0; pi < tpvData.productos.length; pi++) {
                console.log("[C3-tpvsKeysData]");
                var prodData = tpvData.productos[pi].producto;
                if (prodData) {
                  console.log("prodData", prodData);
                  if (prodData.PLU2 === "Formatos") { esFormatoExistente = true; break; }
                  if (prodData.PLU2 === "Tarifas") { esTarifaExistente = true; break; }
                }
              }
            }
            console.log("esFormatoExistente", esFormatoExistente);
            if (esFormatoExistente || esTarifaExistente) break;
          }

          console.log("esFormatoExistente result", esFormatoExistente);
          if (esFormatoExistente) {
            this.crearMultiplesProductosByUdsMedida = true;
            console.log("A-TEST:7", this.crearMultiplesProductosByUdsMedida);
            this.udMedidaChoiceMade = true;
            // console.log("[BC] Producto Formato detectado - abriendo como Formato");
            // Construir productosMultiples con datos existentes de la BD
            this._buildProductosMultiplesDesdeFormato();
          } else if (esTarifaExistente) {
            console.log("N0");
            this.crearMultiplesProductosByUdsMedida = false;
            console.log("A-TEST:8", this.crearMultiplesProductosByUdsMedida);
            this.udMedidaChoiceMade = true;
            // console.log("[BC] Producto Tarifa detectado - abriendo como Tarifa");
          }

          // Actualizar DOM y pasar al siguiente step
          this.$nextTick(() => {
            this.moveStep(2);
          });
        } else {
          console.warn("No se encontraron datos del producto");
          this.loadingGeneral.close();
        }
      } catch (error) {
        console.error(
          "Error al obtener datos del producto a actualizar:",
          error
        );
        this.loadingGeneral.close();
      }
    },

    // Es el mismo que getProductDataInfo, pero sin el parámetro changeFormatToRates
    // Para controlar mejor el flujo separado de un producto normal y los con/suple
    // aunque en esencia, hará lo mismo, por si necesito modificar algo a futuro.
    async getSpecialProductDataInfo(idProdBusinessCentral, goForm = false) {
      // console.log("Se ha llamado a getSpecialProductDataInfo");

      const config = {
        params: {
          jwt: this.$store.getters.jwt,
          listBusinesses: this.listBusinesses.map((b) => b.id).join(","),
          idProdBusinessCentral: idProdBusinessCentral,
        },
        headers: {
          Authorization: "Bearer " + this.$store.getters.jwt,
        },
      };

      try {
        const response = await this.axios.get(
          this.$store.getters.apiUrl + "products/getProductDataInfo",
          config
        );

        const productData = response.data.productDataInfo;
        this.productDataInfo = JSON.parse(JSON.stringify(productData));

        // Actualizar las flags
        this.updateProductTypeFlags();

        if (response.data.response && productData && productData.tpvs) {
          // console.log(" > Datos del producto a actualizar:", productData);
          this.loadingGeneral.close();

          // Extraer los idTpv de la respuesta
          const tpvIds = Object.keys(productData.tpvs);

          // Encontrar los TPVs correspondientes en tpvServerList
          const selectedTpvs = this.tpvServerList.filter((tpv) =>
            tpvIds.includes(tpv.idTpvServer.toString())
          );

          // Actualizar las listas de TPVs seleccionados
          this.selectedTpvServerList = [...selectedTpvs];
          this.selectedTpvServerNameList = selectedTpvs.map(
            (tpv) => tpv.nameShow
          );

          // Sincronizar la UI
          this.syncSelectedTpvServers();

          // Guardar los datos del producto
          this.$set(this, "productosPorTpvRecuperados", productData.tpvs);

          if (goForm) {
            // Actualizar DOM y pasar al siguiente step
            this.$nextTick(() => {
              this.moveStep(2);
            });
          }
        } else {
          console.warn("No se encontraron datos del producto");
          this.loadingGeneral.close();
        }
      } catch (error) {
        console.error(
          "Error al obtener datos del producto a actualizar:",
          error
        );
        this.loadingGeneral.close();
      }
    },

    async getActiveDepartmentsFromTpvServerList(idProductsNumier) {
      if (!idProductsNumier) {
        console.warn("No hay producto seleccionado con ID válido.");
        return Promise.resolve([]);
      }

      const config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };

      const body = {
        idProductsNumier: idProductsNumier,
        params: {
          jwt: this.$store.getters.jwt,
        },
      };

      const vm = this;
      return new Promise((resolve, reject) => {
        this.axios
          .post(
            this.$store.getters.apiUrl + "products/getActiveDepartments",
            body,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.activeDepartments = response.data.productActivity || [];
              resolve(vm.activeDepartments);
            }
          })
          .catch(function (error) {
            console.error(
              "Error al obtener relaciones de subproductos:",
              error
            );
            vm.loadingGeneral.close();
            reject(error);
          });
      });
    },

    fillSelectedTpvServerListByProductsData() {
      const vm = this;
      if (
        this.productsDataToFillForm &&
        this.productsDataToFillForm.length > 0
      ) {
        this.selectedTpvServerList = this.productsDataToFillForm.map((p) => {
          // Buscar el TPV en la lista general por idTpvServer o idBusiness
          const tpv = this.tpvServerList.find(
            (t) => t.idTpvServer == p.idTpv || t.idBusiness == p.idTpv
          );
          // Si no existe en la lista, crea el objeto con los datos del producto
          return tpv
            ? {
              idTpvServer: tpv.idTpvServer,
              nameShow: tpv.nameShow,
              idBusiness: tpv.idBusiness,
              idCategory: p.idCategory || null,
              iva1: tpv.iva1,
              iva2: tpv.iva2,
              iva3: tpv.iva3,
              iva4: tpv.iva4,
              iva5: tpv.iva5,
            }
            : {
              idTpvServer: p.idTpv,
              nameShow: p.name || p.nameShow || "",
              idBusiness: null,
              idCategory: p.idCategory || null,
              iva1: p.vatType || null,
              iva2: null,
              iva3: null,
              iva4: null,
              iva5: null,
            };
        });
      } else {
        this.selectedTpvServerList = [];
      }

      // if (!notStopLoading){
      //   this.loadingGeneral.close();
      //   // console.log("se cierra");
      // } else {
      //   // console.log("no se cierra");
      // }
    },

    goBackToStep1() {
      this.productoSeleccionado = {
        idProdBusinessCentral: 0,
        productName: "",
        tipoIVA: "",
      };
      this.selectedTpvServerList = [];
      this.selectedTpvServerNameList = [];
      this.allTpvServerSelectedBoolean = false;
      this.finalizeButtonPressed = false; //  Es posible que el finalizeButtonPressed no sea necesario, pertenece al legacy de cuando se guardaba en el productoFormBasico
      this.continueButtonPressedOnStep3 = false;

      // Reiniciar variables relacionadas con múltiples productos
      this.crearMultiplesProductosByUdsMedida = false;
      console.log("A-TEST:9", this.crearMultiplesProductosByUdsMedida);
      this.productosMultiples = [];
      this.udMedidaChoiceMade = false;

      this.recetaSeleccionada = [];
      this.addMateriaPrimaButtonsPressed = [];
      this.addAllMateriaPrimaButtonPressed = false;

      this.productsDataToFillForm = [];

      this.moveStep(1);
      // console.log(" > Vaciamos productsDataToFillForm y goBackToStep1", this.productsDataToFillForm);
    },

    // Método para guardar productos con sus materias primas
    saveProducts() {
      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      // Configuración común
      let config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };

      // console.log("> El prod", this.productosPorTpvRecuperados);
      // console.log("> Materias primas", this.recetaSeleccionada);

      // Preparar los parámetros base
      let params = {
        jwt: this.$store.getters.jwt,
        productos: this.productosPorTpvRecuperados,
        listBusinesses: this.listBusinesses,
        materiasPrimas: [],
        productoBusinessCentral: {
          id: this.productoSeleccionado.idProdBusinessCentral,
          nombre: this.productoSeleccionado.productName,
        },
      };

      // console.log("> Parametros", params);

      // Si hay receta seleccionada, añadir la información de materias primas
      if (this.recetaSeleccionada && this.recetaSeleccionada.length > 0) {
        // Preparar los datos de las materias primas con sus precios
        params.materiasPrimas = this.recetaSeleccionada.map((materia) => ({
          idMateriaPrimaBusinessCentral: materia.idMateriaPrimaBusinessCentral,
          nombreMateriaPrima: materia.nombreMateriaPrima,
          cantidad: parseFloat(materia.cantidadMateriaPrima) || 0,
          udMedida: materia.udMedidaMateriaPrima,
          tipoMateriaPrima: materia.tipoMateriaPrima || "",
          // precioMateriaPrima: parseFloat(materia.precioMateriaPrima) || 0
        }));

        // Añadir información del producto Business Central
        params.productoBusinessCentral = {
          id: this.productoSeleccionado.idProdBusinessCentral,
          nombre: this.productoSeleccionado.productName,
        };
      }

      let vm = this;

      // Determinar qué endpoint usar basado en el tipo de producto
      const endpoint =
        this.productoSeleccionado.MostrarEnListaCON ||
          this.productoSeleccionado.MostrarEnListaSUPLEMENTO
          ? "products/saveAdvancedProductBusinessCentral"
          : "businesscentral/saveRecipies";

      // Si es un producto avanzado (CON/SUPLEMENTO), ajustar la estructura
      if (endpoint === "products/saveAdvancedProductBusinessCentral") {
        // ----- LIMPIEZA: construir productosLimpios para no enviar objetos vacíos -----
        const productosLimpios = {};

        // siempre incluir producto si existe
        if (
          this.productosPorTpvRecuperados &&
          this.productosPorTpvRecuperados.producto
        ) {
          productosLimpios.producto = this.productosPorTpvRecuperados.producto;
        }

        // incluir 'con' solo si el flag y el objeto tienen contenido útil
        if (
          this.productoSeleccionado.MostrarEnListaCON &&
          this.productosPorTpvRecuperados &&
          this.productosPorTpvRecuperados.con &&
          Object.keys(this.productosPorTpvRecuperados.con).length > 0
        ) {
          productosLimpios.con = this.productosPorTpvRecuperados.con;
        }

        // incluir 'suplemento' solo si el flag y el objeto tienen contenido útil
        if (
          this.productoSeleccionado.MostrarEnListaSUPLEMENTO &&
          this.productosPorTpvRecuperados &&
          this.productosPorTpvRecuperados.suplemento &&
          Object.keys(this.productosPorTpvRecuperados.suplemento).length > 0
        ) {
          productosLimpios.suplemento =
            this.productosPorTpvRecuperados.suplemento;
        }

        // Construir newParams usando productosLimpios en lugar del original
        const newParams = {
          jwt: this.$store.getters.jwt,
          productos: productosLimpios,
          listBusinesses: this.listBusinesses,
          materiasPrimas: params.materiasPrimas,
          productoBusinessCentral: params.productoBusinessCentral,
        };

        // Actualizar params con la nueva estructura limpia
        params = newParams;
      }

      // Guardar PLU1 de productos que se están guardando para eliminarlos después.
      this.productosGuardandose = this._extractProductosPLU1(this.productosPorTpvRecuperados);
      const codigoBCSeleccionado = this.productoSeleccionado
        ? String(this.productoSeleccionado.idProdBusinessCentral || this.productoSeleccionado.PLU1 || "").trim()
        : "";
      if (codigoBCSeleccionado && !this.productosGuardandose.includes(codigoBCSeleccionado)) {
        this.productosGuardandose.push(codigoBCSeleccionado);
      }
      // console.log("📦 Productos a guardar (PLU1):", this.productosGuardandose);

      // Llamar al endpoint correspondiente
      return this.axios
        .post(this.$store.getters.apiUrl + endpoint, params, config)
        .then((response) => vm.handleSaveResponse(response))
        .catch((error) => vm.handleSaveError(error));
    },

    // Helper: Extrae PLU1 de los productos que se envían
    _extractProductosPLU1(productos) {
      const plu1s = [];

      if (Array.isArray(productos)) {
        // Si es un array de productos
        productos.forEach(p => {
          if (p && p.PLU1) plu1s.push(String(p.PLU1).trim());
        });
      } else if (productos && typeof productos === 'object') {
        // Si es un objeto con estructura { producto: {...}, con: {...}, suplemento: {...} }
        Object.values(productos).forEach(item => {
          if (item && typeof item === 'object') {
            if (item.PLU1) {
              plu1s.push(String(item.PLU1).trim());
            }
            if (Array.isArray(item)) {
              item.forEach(i => {
                if (i && i.PLU1) plu1s.push(String(i.PLU1).trim());
              });
            }
          }
        });
      }

      return plu1s;
    },

    /**
     * Edita un producto en Business Central utilizando la API
     * @param {Object} productosNormalizados - Datos del producto normalizados para la API
     */
    async editProductBC(productosNormalizados) {
      // console.log(" > Enviando producto a Business Central:", JSON.stringify(productosNormalizados));

      if (
        !productosNormalizados ||
        !productosNormalizados.tpvs ||
        productosNormalizados.tpvs.length === 0
      ) {
        console.warn("No hay datos de producto para actualizar");
        return;
      }

      this.loadingGeneral = Loading.service({ text: this.$t("cargando") });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var body = {
        jwt: this.$store.getters.jwt,
        productos: productosNormalizados,
        flags: this.productTypeFlags,
      };
      // Para productos simples pendientes de actualizar con una sola unidad de medida,
      // debemos asegurarnos de que la udMedida en el body refleje la nueva unidad de medida de BC
      if (
        this.productoSeleccionado.tipoPendiente === "pendienteActualizar" &&
        Array.isArray(this.productoSeleccionado.udMedida) &&
        this.productoSeleccionado.udMedida.length === 1 &&
        !this.crearMultiplesProductosByUdsMedida
      ) {
        // La udMedida en productoSeleccionado es un array de strings (ej: ["KILO"])
        console.log("A-TEST:10", this.crearMultiplesProductosByUdsMedida);
        body.productos.productBC.udMedida = [
          this.productoSeleccionado.udMedida[0],
        ];
        body.productos.productBC.tieneSubproducts = false;
      }

      // Para productos tipo "Simple" que vienen con múltiples udMedida pero deberían tener solo una,
      // tomamos la udMedida desde el PLU4 del producto en TPV
      if (
        this.productoSeleccionado.tipoPendiente === "pendienteActualizar" &&
        body.productos &&
        body.productos.tpvs &&
        body.productos.tpvs.length > 0 &&
        body.productos.tpvs[0].prods &&
        body.productos.tpvs[0].prods.length > 0
      ) {
        const primerProducto = body.productos.tpvs[0].prods[0];
        // Si es un producto tipo "Simple" y tiene PLU4 definido, usar esa udMedida
        if (primerProducto.PLU2 === "Simple" && primerProducto.PLU4) {
          // console.log( "[BC] Producto Simple detectado. Normalizando udMedida a:", primerProducto.PLU4);
          body.productos.productBC.udMedida = [primerProducto.PLU4];
          body.productos.productBC.tieneSubproducts = false;
        }
      }

      // Determinar qué endpoint usar basado en el tipo de producto
      const endpoint =
        this.productoSeleccionado.MostrarEnListaCON ||
          this.productoSeleccionado.MostrarEnListaSUPLEMENTO
          ? "businesscentral/editProductAdvanced"
          : "businesscentral/editProduct";

      // console.log("> productosNormalizados", productosNormalizados);

      try {
        const response = await this.axios.post(
          this.$store.getters.apiUrl + endpoint,
          body,
          config
        );

        if (
          (response.data &&
            response.data.editedIds &&
            response.data.editedIds.length > 0) ||
          (response.data && response.data.response)
        ) {
          // console.log("Producto editado con éxito");
          if (this.loadingGeneral) this.loadingGeneral.close();

          // Eliminar el producto actualizado de la lista de pendientes
          if (
            productosNormalizados &&
            productosNormalizados.tpvs &&
            productosNormalizados.tpvs.length > 0
          ) {
            // const updatedProductId = productosNormalizados.tpvs[0].idProdBusinessCentral;
            const updatedProductId =
              productosNormalizados.productBC.idProdBusinessCentral;
            // const initialLength = this.productosPendientes.length;

            // console.log("productosNormalizados", productosNormalizados);
            // console.log("updatedProductId", updatedProductId);
            // console.log("this.productosPendientes", this.productosPendientes);

            // Eliminar solo el producto que se acaba de actualizar
            this.productosPendientes = this.productosPendientes.filter(
              (p) =>
                String(p.idProdBusinessCentral) !== String(updatedProductId)
            );

            // console.log(`Quitado ${initialLength - this.productosPendientes.length} productos de la lista`);
          }

          // Preguntar al usuario si quiere terminar o seguir
          Swal.fire({
            title: this.$t("swalProductoSincronizadoTitle"),
            text:
              this.productosPendientes.length > 0
                ? this.$t("swalProductoSincronizadoTextNPendientes")
                : this.$t("swalProductoSincronizadoText0Pendientes"),
            type: "success",
            showCancelButton: this.productosPendientes.length > 0,
            cancelButtonText: this.$t("swalProductoSincronizadoButtonTerminar"),
            confirmButtonText: this.$t("swalProductoSincronizadoButtonSeguir"),
            buttonsStyling: true,
            cancelButtonClass: "btn btn-primary btn-fill",
            cancelButtonColor: "#1a73e8",
            confirmButtonClass:
              "btn btn-outline-primary btn-fill swal2-cancel-btn",
            confirmButtonColor: "#aaaaaa",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
              // El usuario hizo clic en "Terminar"
              this.$router.push("/businesscentral");
            } else {
              // El usuario hizo clic en "Seguir" o cerró el diálogo
              // Debo quitar de la lista el elemento
              if (this.waitingForProductsData) {
                this.waitingForProductsData = false;
                this.currentStep = 1;

                this.$nextTick(() => {
                  this.$nextTick(() => {
                    this.updateProgressBar();
                  });
                });
              }
            }
          });
        } else {
          console.warn("No se pudieron editar productos.");
          if (this.loadingGeneral) this.loadingGeneral.close();
          Swal.fire({
            title: this.$t("error"),
            text: this.$t("serverError"),
            type: "error",
            confirmButtonText: this.$t("vale"),
          });
        }
      } catch (error) {
        console.error(
          "Error al editar productos:",
          error && error.message ? error.message : error
        );
        if (this.loadingGeneral) this.loadingGeneral.close();
        Swal.fire({
          title: this.$t("error"),
          text: this.$t("serverError"),
          type: "error",
          confirmButtonText: this.$t("vale"),
        });
      }
    },

    async editProducts(productIndex = null, options = {}) {
      const { silent = false } = options;

      var productosAEnviar = [];

      if (
        Array.isArray(this.productosPorTpvRecuperados) &&
        this.productosPorTpvRecuperados.length > 0
      ) {
        productosAEnviar = this.productosPorTpvRecuperados;
      } else if (this.productoSeleccionado) {
        productosAEnviar = [Object.assign({}, this.productoSeleccionado)];
      } else {
        console.warn("No hay productos para editar");
        return { success: false, message: "No hay producto seleccionado" };
      }

      if (!silent) {
        this.loadingGeneral = Loading.service({ text: this.$t("cargando") });
      }

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var body = {
        jwt: this.$store.getters.jwt,
        productos: productosAEnviar,
      };

      if (
        productosAEnviar.length > 0 &&
        productosAEnviar[0].PLU2 === "Formatos" &&
        this.productDataInfo &&
        Object.keys(this.productDataInfo).length > 0
      ) {
        const productosNormalizados = this.normalizeProductosNumier(
          productosAEnviar,
          this.productDataInfo
        );
        body.productos = productosNormalizados;
      }

      try {
        const response = await this.axios.post(
          this.$store.getters.apiUrl + "businesscentral/editProduct/auto",
          body,
          config
        );

        const success =
          (response.data && response.data.editedIds && response.data.editedIds.length > 0) ||
          (response.data && response.data.response);

        if (success) {
          if (!silent && this.loadingGeneral) this.loadingGeneral.close();

          if (productosAEnviar.length > 0) {
            const updatedProductId = productosAEnviar[0].idProdBusinessCentral;
            this.productosPendientes = this.productosPendientes.filter(
              (p) => p.idProdBusinessCentral !== updatedProductId
            );
            this.currentPage = 1;
          }

          if (silent) return { success: true };

          Swal.fire({
            title: this.$t("swalProductoSincronizadoTitle"),
            text:
              this.productosPendientes.length > 0
                ? this.$t("swalProductoSincronizadoTextNPendientes")
                : this.$t("swalProductoSincronizadoText0Pendientes"),
            type: "success",
            showCancelButton: this.productosPendientes.length > 0,
            cancelButtonText: this.$t("swalProductoSincronizadoButtonTerminar"),
            confirmButtonText: this.$t("swalProductoSincronizadoButtonSeguir"),
            buttonsStyling: true,
            cancelButtonClass: "btn btn-primary btn-fill",
            cancelButtonColor: "#1a73e8",
            confirmButtonClass: "btn btn-outline-primary btn-fill swal2-cancel-btn",
            confirmButtonColor: "#aaaaaa",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.value) this.shouldRedirect = true;
          });

          return { success: true };
        } else {
          if (!silent) {
            console.warn("No se pudieron editar productos.");
            if (this.loadingGeneral) this.loadingGeneral.close();
            Swal.fire({
              title: this.$t("error"),
              text: this.$t("serverError"),
              type: "error",
              confirmButtonText: this.$t("vale"),
            });
          }
          return { success: false, message: response.data && response.data.message };
        }
      } catch (error) {
        if (!silent) {
          console.error("Error al editar productos:", error && error.message ? error.message : error);
          if (this.loadingGeneral) this.loadingGeneral.close();
          Swal.fire({
            title: this.$t("error"),
            text: this.$t("serverError"),
            type: "error",
            confirmButtonText: this.$t("vale"),
          });
        }
        return { success: false, message: error.message };
      }
    },

    async sincronizarTodosAuto() {
      const eligibles = this.productosAutoEditables;

      if (eligibles.length === 0) {
        Swal.fire({
          title: this.$t("atencion"),
          text: this.$t("noHayProductosAutoEditables"),
          type: "info",
          confirmButtonText: this.$t("vale"),
        });
        return;
      }

      const confirm = await Swal.fire({
        title: this.$t("confirmarSincronizacionMasivaTitle"),
        text: this.$t("confirmarSincronizacionMasivaText", { COUNT: eligibles.length }),
        type: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("siSincronizar"),
        cancelButtonText: this.$t("cancelar"),
      });

      if (!confirm.value) return;

      const resultados = { ok: [], error: [] };
      let procesados = 0;

      const actualizarLoading = () => {
        if (this.loadingGeneral) this.loadingGeneral.close();
        this.loadingGeneral = Loading.service({
          text: `${this.$t("sincronizando")} (${procesados}/${eligibles.length})`,
        });
      };

      actualizarLoading();

      for (const producto of eligibles) {
        let resultado;

        try {
          const flags = producto.flags || {};

          if (flags.requires_full_form && flags.transparent_update) {
            // Caso CON/SUPLEMENTO transparente
            this.productoSeleccionado = { ...producto };
            resultado = await this.saveAdvancedProductTransparent({ silent: true });
          } else {
            // Caso normal
            const activeDepartments = await this.getActiveDepartmentsFromTpvServerList(
              producto.idsNumier
            );

            this.selectedTpvServerList = (activeDepartments || []).map((d) => d.businessName);
            this.selectedTpvServerNameList = [...this.selectedTpvServerList];
            this.syncSelectedTpvServers();
            this.updateSelectAllTpvStatus();

            this.productoSeleccionado = { ...producto };
            this.productosPorTpvRecuperados = null; // evita reusar datos de un producto anterior

            resultado = await this.editProducts(null, { silent: true });
          }
        } catch (error) {
          resultado = { success: false, message: error.message };
        }

        procesados++;
        actualizarLoading();

        if (resultado && resultado.success) {
          resultados.ok.push(producto.idProdBusinessCentral);
        } else {
          resultados.error.push({
            id: producto.idProdBusinessCentral,
            nombre: producto.productName,
            motivo: (resultado && resultado.message) || this.$t("errorDesconocido"),
          });
        }
      }

      if (this.loadingGeneral) {
        this.loadingGeneral.close();
        this.loadingGeneral = null;
      }
      this.currentPage = 1;

      const htmlErrores =
        resultados.error.length > 0
          ? `<br><br><div style="text-align:left;max-height:200px;overflow-y:auto;">${resultados.error
              .map((e) => `- ${e.nombre || e.id}: ${e.motivo}`)
              .join("<br>")}</div>`
          : "";

      Swal.fire({
        title: this.$t("sincronizacionMasivaCompletadaTitle"),
        html: `${this.$t("sincronizadosCorrectamente")}: ${resultados.ok.length} / ${eligibles.length}${htmlErrores}`,
        type: resultados.error.length > 0 ? "warning" : "success",
        confirmButtonText: this.$t("vale"),
      });
    },
  },
};
</script>

<style scoped>
/* Estilos para la lista de materias primas */
.materias-primas-container {
  border-radius: 8px;
  padding: 30px 10vw 45px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin: 20px auto;
  background: #f8f9fa;
  max-width: 1000px;
  width: 100%;
  box-sizing: border-box;
}

.materias-primas-list {
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 15px;
  padding-right: 10px;
}

.materia-prima-item {
  margin-bottom: 10px;
  padding: 12px 15px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.materia-prima-item:hover {
  transform: translateX(5px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.materia-prima-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.materia-prima-name {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}

.materias-primas-note {
  background: #f0f7ff;
  padding: 12px 15px;
  border-radius: 6px;
  font-size: 14px;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 10px;
  border-left: 4px solid #4a90e2;
  margin-top: 15px;
}

/* Scrollbar personalizada */
.materias-primas-list::-webkit-scrollbar {
  width: 6px;
}

.materias-primas-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.materias-primas-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.materias-primas-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.stepper-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
  margin-top: 15px;
}

.flex-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
  width: 50%;
  left: 10%;
  right: 10%;
  margin-right: 75px;
}

/* Centrar el stepper en el paso 1 */
.stepper-wrapper.center-step-1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50% !important;
  margin: 0 auto !important;
}

.stepper-wrapper.center-step-1 .flex-container {
  width: 100% !important;
  max-width: 800px;
  min-width: 320px;
  margin: 0 !important;
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%);
  margin-right: 0 !important;
  align-self: center;
  float: none !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  /* justify-content: center; */
  gap: 40px;
}

/* Ocultar los botones del contenedor del step 1 para poder centrar el stepper */
.stepper-wrapper.center-step-1 .stepper-buttons {
  display: none;
}

/* Evitar que los pasos se estiren cuando se centran */
.stepper-wrapper.center-step-1 .step {
  flex: 0 0 auto;
}

.progress {
  position: absolute;
  top: 28%;
  left: 6.5%;
  right: 6.5%;
  width: 85%;
  height: 5px;
  background-color: #cdcdcd;
  z-index: 1;
}

.stepper-wrapper.center-step-1 .progress {
  top: 25%;
  left: 0;
  right: 0;
  width: 100%;
}

.progress-bar {
  height: 100%;
  background-color: #46c0bd;
  transition: width 0.3s ease-in-out;
  z-index: 2;
}

.step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 3;
}

.step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #cdcdcd;
  padding: 0.5em;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 12px;
  color: white;
  z-index: 2;
  transition: background-color 0.3s ease-in-out;
}

.step.current .step-number {
  background-size: 200% 200%;
  transition: all 0.4s 0.5s;
  background-color: #ffab40;
}

.step.done .step-number {
  background-color: #46c0bd;
}

.step-label {
  justify-content: center;
  padding-top: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #858585;
  white-space: pre-line;
}

/* Estilo de deshabilitación para el botón continuar */
.continue-btn:disabled,
.continue-btn[disabled] {
  background-color: #cccccc !important;
  color: #888888 !important;
  border-color: #cccccc !important;
  cursor: not-allowed !important;
}

.stepper-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 45px;
  margin-bottom: 55px;
  margin-right: 20%;
  margin-left: 5%;
}

.continue-btn {
  display: block;
}

.continue-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.hidden {
  visibility: hidden;
}

.fixed-width-button {
  width: 110px;
  font-size: 14px;
  text-align: center;
}

.fa-chevron-left {
  font-size: 13px;
}

.fa-chevron-right {
  font-size: 13px;
}

.alert-info {
  font-size: 15px;
  color: #0c5460 !important;
  background-color: #ffffff !important;
  border-color: #bee5eb;
  position: relative;
  padding-left: 45px;
  padding-right: 10px;
  padding-bottom: 2px !important;
  margin-left: 20%;
  margin-right: 20%;
  border: 1px solid transparent;
  border-radius: 0.55rem;
  box-sizing: border-box;
  margin-bottom: 30px;
}

.fa-info-circle {
  position: absolute;
  left: 20px;
  top: 14px;
  right: 10px;
  bottom: 15px;
  font-size: 15px;
  color: #0c5460;
}

.alert-container-wide {
  margin-left: 20px;
  width: 94%;
}

.alert-container-normal {
  width: 100%;
}

.table-container {
  margin-left: 15%;
  margin-right: 15%;
  width: 80%;
  /* overflow-x: auto; */
}

.product-table {
  width: 85%;
  border-collapse: collapse;
  background-color: #f7f7f8;
}

.product-table th,
.product-table td {
  padding: 10px;
  padding-top: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  text-align: left;
  font-size: 15px;
}

/* Quitar el borde superior de la primera fila y el borde inferior de la última fila */
.product-table tr:first-child th {
  border-top: none;
}

.product-table tr:last-child td {
  border-bottom: none;
}

.product-table th {
  padding-bottom: 10px;
  background-color: #f7f7f8;
}

.product-table th:last-child,
.product-table td:last-child {
  width: 160px;
  text-align: center;
}

.select-btn {
  width: 120px;
  font-size: 15px;
  padding: 5px 10px;
  text-align: center;
}

.add-all-btn {
  background-color: white;
  border: 1px solid #007bff;
  color: #007bff;
  min-width: 150px;
  float: right;
  margin-right: 18%;
  white-space: nowrap;
}

.icon-check-table {
  font-size: 13px;
}

.row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.departments-card {
  width: 35%;
  background-color: #fff;
  padding-left: 20px;
  padding-top: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.departments-card h3 {
  margin-bottom: 10px;
  margin-left: 12px;
  font-size: 20px;
}

.checkbox-tree-container {
  margin-right: 8px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

.checkbox-item label {
  font-size: 16px;
  cursor: pointer;
}

.checkbox-item input {
  font-size: 16px;
  cursor: pointer;
  line-height: 1;
}

.custom-checkbox {
  width: 17px;
  height: 17px;
  margin-right: 10px;
  cursor: pointer;
  appearance: none;
  border: 2px solid #a5a5a5;
  border-radius: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease-in-out;
  margin-bottom: 9px;
}

.custom-checkbox:checked {
  background-color: #46c0bd;
  border: 2px solid #46c0bd;
}

.custom-checkbox:checked::after {
  content: "✔";
  color: white;
  font-size: 11px;
  font-weight: bold;
  position: absolute;
}

.select-all-checkbox {
  font-weight: bold;
}

.divider {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin-top: 5px;
  margin-bottom: 15px;
  width: 95%;
}

.tags-container {
  font-size: 16px;
  padding-left: 10px;
  background-color: #ffffff !important;
  border: 1px;
}

.tags-container /deep/ .badge {
  background-color: #fff;
  border: 1px solid #ccc;
  color: #777;
  font-size: 16px;
  font-weight: normal;
  margin: 5px;
  padding: 5px 10px;
  border-radius: 5px;
}

.tags-container /deep/ .badge:hover {
  background-color: #f1f1f1;
}

.tags-container /deep/ .badge .close {
  color: #777;
  font-size: 18px;
  margin-left: 18px;
  margin: 3px;
  padding-left: 10px;
}

.product-fields-container {
  margin-left: 10%;
  margin-right: 10%;
  width: 80%;
}

.swal2-icon {
  font-size: 14px;
}

/* Estilos para el buscador */
.search-container {
  margin: 20px 15% 30px 15%;
  width: 70%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 15px;
  color: #888;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 12px 15px 12px 45px;
  border: 2px solid #ddd;
  border-radius: 25px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s ease;
}

.search-input:focus {
  border-color: #447df7;
}

.clear-search-btn {
  position: absolute;
  right: 15px;
  background: none;
  border: none;
  color: #888;
  cursor: pointer;
  font-size: 16px;
  padding: 5px;
  transition: color 0.3s ease;
}

.clear-search-btn:hover {
  color: #333;
}

/* Estilos para las tabs */
.tabs-container {
  margin: 0 15% 20px 15%;
  width: 70%;
}

/* Tabs a la izquierda y acciones de la pestana activa a la derecha,
   compartiendo la misma linea base */
.tabs-bar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 16px;
  border-bottom: 2px solid #dee2e6;
}

.nav-tabs {
  border-bottom: 2px solid #dee2e6;
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.tabs-bar .nav-tabs {
  border-bottom: none;
  flex: 1 1 auto;
  min-width: 0;
  flex-wrap: wrap;
}

.tabs-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding-bottom: 8px;
}

.bulk-sync-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
  line-height: 1;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.bulk-sync-btn:hover {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.18);
  transform: translateY(-1px);
}

.bulk-sync-count {
  display: inline-block;
  min-width: 22px;
  padding: 2px 7px;
  border-radius: 11px;
  background-color: rgba(255, 255, 255, 0.25);
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

@media (max-width: 991px) {
  .tabs-bar {
    align-items: stretch;
  }

  .tabs-actions {
    width: 100%;
    justify-content: flex-end;
    padding-bottom: 10px;
  }
}

.nav-item {
  margin-bottom: -2px;
}

.nav-link {
  display: block;
  padding: 12px 20px;
  text-decoration: none;
  color: #495057;
  background-color: transparent;
  border: 2px solid transparent;
  border-bottom: none;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  transition: all 0.3s ease;
  font-weight: 500;
  cursor: pointer;
}

.nav-link:hover {
  color: #1abbb8;
  background-color: #f9faf8;
}

.nav-link.active {
  color: #46c0bd;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
  font-weight: 600;
}

/* Estilos para el contenido de las tabs */
.tab-content {
  margin-top: 20px;
}

.tab-pane {
  display: block;
}

.no-results {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
  font-style: italic;
}

.no-results p {
  margin: 0;
  font-size: 16px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 1rem 0 0 5%;
  width: 70%;
  flex-wrap: wrap;
}

.page-item {
  margin: 2px 2px;
}

.page-link {
  display: block;
  padding: 8px 12px;
  text-decoration: none;
  color: #46c0bd;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.page-link:hover {
  color: #fff;
  background-color: #1abbb8;
  border-color: #1abbb8;
}

.page-item.active .page-link {
  color: #fff;
  background-color: #46c0bd;
  border-color: #46c0bd;
}

.page-item.disabled .page-link {
  color: #6c757d;
  background-color: #fff;
  border-color: #dee2e6;
  cursor: not-allowed;
}

.page-item.disabled .page-link:hover {
  color: #6c757d;
  background-color: #fff;
  border-color: #dee2e6;
}

.finalize-btn {
  background-color: #28a745;
  border-color: #28a745;
  color: #fff;
}

.finalize-btn:disabled,
.finalize-btn[disabled] {
  background-color: #cccccc !important;
  border-color: #cccccc !important;
  color: #888888 !important;
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Integraciones/BusinessCentral/Productos/ProductosBusinessCentral.vue